window.__lc = window.__lc || {};
window.__lc.license = 12834777;

_theme.initSlideShow = function(){
  if(jQuery('[data-init-slideshow]').length){
    jQuery('[data-init-slideshow]').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }

  if(jQuery('.brand-slider-items').length) {
    const sliderSettings = {
      dots: false,
      arrows: true,
      autoplay:true,
      infinite: false,
      slidesToShow: 7,
      slidesToScroll: 3,
      responsive: [
        { breakpoint: 1500, settings: { slidesToShow: 6 }},
        { breakpoint: 1300, settings: { slidesToShow: 5 }},
        { breakpoint: 1200, settings: { slidesToShow: 5, slidesToScroll: 3 }},
        { breakpoint: 800, settings: { slidesToShow: 4, slidesToScroll: 3 }},
        { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2, dots: true }},
        { breakpoint: 1, settings: { slidesToShow: 2, slidesToScroll: 2, dots: true }}
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    };

    initBrandSlider(false);

    function initBrandSlider(autoplay){
      if(autoplay){
        sliderSettings.autoplay = autoplay;
        sliderSettings.autoplaySpeed = 1000;
        sliderSettings.speed = 2000;
        sliderSettings.autoplaySpeed = 1000;
        sliderSettings.speed = 2000;
      }
      if(jQuery('.brand-slider-items').hasClass('slick-initialized')){
        jQuery('.brand-slider-items').slick('unslick');
      }
      // jQuery('.brand-slider-items').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      //   jQuery('.brand-slider-items .slick-slide').removeAttr('tabindex');
      // });

      jQuery('.brand-slider-items').on('afterChange', function(event, slick, currentSlide, nextSlide){
        slick.$slider.find('button.slick-arrow').attr('tabindex', 0);
        slick.$slider.find('button.slick-arrow[aria-disabled="true"]').attr('tabindex', -1);
      });
      jQuery('.brand-slider-items').on('init', function(event, slick, currentSlide, nextSlide){
        slick.$slider.find('button.slick-arrow').attr('tabindex', 0);
        slick.$slider.find('button.slick-arrow[aria-disabled="true"]').attr('tabindex', -1);
      });

      jQuery('.brand-slider-items').on('beforeChange afterChange', function(event, slick, currentSlide, nextSlide){
        setTimeout(function() {
          slick.$slider.find('.slick-slide').removeAttr('role');
        },100);
      });

      jQuery('.brand-slider-items').slick(sliderSettings);
      // jQuery('#brands-slider-status').text('brands carousel is ' + (autoplay ? 'running' : 'paused'));
      // let btnText = autoplay ? 'pause carousel' : 'play carousel';
      // $toggleSliderBtn.text(btnText).attr('aria-label', btnText);
      // isAutoplay = autoplay;

      let brandSlideDots = document.querySelectorAll('.brand-slider-items .slick-dots li button');
      setTimeout(function(){
        if(brandSlideDots.length > 0){
          for(let i=0; i<brandSlideDots.length; i++){
            brandSlideDots[i].setAttribute('role', 'button');
            brandSlideDots[i].parentElement.classList.contains('slick-active') ? brandSlideDots[i].setAttribute('aria-label', `Current slide ${i+1} of ${brandSlideDots.length}`) : brandSlideDots[i].setAttribute('aria-label', `Slide ${i+1} of ${brandSlideDots.length}`);
          }
        }
        jQuery('.brand-slider-items .slick-dots, .brand-slider-items .slick-dots li').removeAttr('role');
        jQuery('.brand-slider-items .slick-dots li.slick-active button').removeAttr('aria-selected');
      },300)
      $('.brand-slider-items').on('afterChange', function(event, slick, currentSlide, nextSlide){
        setTimeout(function(){
          if(brandSlideDots.length > 0){
            for(let i=0; i<brandSlideDots.length; i++){
              brandSlideDots[i].setAttribute('role', 'button');
              brandSlideDots[i].parentElement.classList.contains('slick-active') ? brandSlideDots[i].setAttribute('aria-label', `Current slide ${i+1} of ${brandSlideDots.length}`) : brandSlideDots[i].setAttribute('aria-label', `Slide ${i+1} of ${brandSlideDots.length}`);
            }
          }
          jQuery('.brand-slider-items .slick-dots, .brand-slider-items .slick-dots li').removeAttr('role');
          jQuery('.brand-slider-items .slick-dots li.slick-active button').removeAttr('aria-selected');
        },300)
      });
    }
    const $parent = jQuery('.brand-slider-items').parent();
    _theme.initSliderPlayPause($parent,jQuery('.brand-slider-items'),'Brand slider');
  }


  if(jQuery('.VDcardlist').length && _theme.isIpadAndUp) {
    _theme.initSlickSlider(jQuery('.VDcardlist'),{
      infinite:false,
      arrows:false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
          {
              breakpoint: 1380,
              settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1,
              }
          },
          {
              breakpoint: 1190,
              settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
              }
          },
          {
              breakpoint: 992,
              settings: "unslick"
          }
      ]
    },function(){
      jQuery('.VDcardlist').on('afterChange', function(event, slick, currentSlide, nextSlide){
      slick.$slider.find('.slick-slide').removeAttr('tabindex');
      slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
      setTimeout(function(){
        slick.$slider.find('.slick-slide').removeAttr('tabindex');
      }, 1000);
      jQuery('.slick-slide').each(function(){
        if(jQuery(this).hasClass('slick-active')){
          jQuery(this).find('.smartwishlist').attr('tabindex','0');
        }
        else{
          jQuery(this).find('.smartwishlist').attr('tabindex','-1');
        }
      });
    });
  });
  }

  if(jQuery('.products-grid.row.five-items.featuredslider2').length){
    _theme.initSlickSlider(jQuery('.products-grid.row.five-items.featuredslider2'),
    {
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      infinite: !1,
      // prevArrow:"<button type='button' class='slick-arrow slick-prev' aria-label='previous'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''></button>",
      // nextArrow:"<button type='button' class='slick-arrow slick-next' aria-label='next'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''></button>",
      responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2.4,
          arrows:true,
          dots:false,
          slidesToScroll: 1,
        }
      }]
    }, 
    function(slick){
      slick.$slider.find('.slick-slide.slick-active .smartwishlist').attr('tabindex', '0');
    },
    function(slick){
      slick.$slider.find('.slick-slide.slick-active .smartwishlist').attr('tabindex', '0');
    }
    );
  }

  // Common slider settings for all sliders
  const commonSlickSettings = {
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    infinite: !1,
    responsive: [
      {
        breakpoint: 1750,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 4.25,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3.4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2.5,
          arrows:true,
          dots:false,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          arrows:true,
          dots:false,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.5,
          arrows:true,
          dots:false,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          arrows:true,
          dots:false,
          slidesToScroll: 1,
        }
      }
    ]
  }
  
  // Selectors based on screen size
  const isDesktop = window.innerWidth > 767;
  
  const gridSelector = isDesktop
    ? '.image-with-text-card-container.style-2-desk-slider'
    : '.image-with-text-card-container';

  // Init slider for grid section
  if (jQuery(gridSelector).length) {
    _theme.initSlickSlider(jQuery(gridSelector), commonSlickSettings);
  }

  const gridStyle2Selector = isDesktop
    ? '.image-with-grid-style-2.style-2-desk-slider'
    : '.image-with-grid-style-2';

  // Init slider for grid style-2 section
  if (jQuery(gridStyle2Selector).length) {
    _theme.initSlickSlider(jQuery(gridStyle2Selector), commonSlickSettings);
  }


    var mobSlider = false;
  if(jQuery('.image-with-text-card-container-2').hasClass('remove-mob-slider')){
      mobSlider = true;
  }
  if(jQuery('.image-with-text-card-container-2').length && (!mobSlider || window.innerWidth > 1024)){
    _theme.initSlickSlider(jQuery('.image-with-text-card-container-2'),
    {
      slidesToShow: 4.6,
      slidesToScroll: 1,
      dots: false,
      infinite: !1,
      autoplay: true,
      autoplaySpeed: 10000,
      responsive: [
        {
          breakpoint: 2000,
          settings: {
            slidesToShow: 3.6,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1750,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 2.6,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.16,
          arrows:true,
          dots:true,
          slidesToScroll: 1,
        }
      }]
    }
    );
    let slideDots = document.querySelectorAll('.image-with-text-card-container-2 .slick-dots li button');
    setTimeout(function(){
      document.querySelectorAll('.image-with-text-card-container-2 .slick-slide').forEach(function (element) {
        const isHidden = element.getAttribute('aria-hidden') === 'true';
        element.setAttribute('tabindex', isHidden ? '-1' : '0');
      });
      if(slideDots.length > 0){
        for(let i=0; i<slideDots.length; i++){
          slideDots[i].setAttribute('role', 'button');
          slideDots[i].parentElement.classList.contains('slick-active') ? slideDots[i].setAttribute('aria-label', `Current slide ${i+1} of ${slideDots.length}`) : slideDots[i].setAttribute('aria-label', `Slide ${i+1} of ${slideDots.length}`);
        }
      }
      jQuery('.image-with-text-card-container-2 .slick-dots, .image-with-text-card-container-2 .slick-dots li').removeAttr('role');
      jQuery('.image-with-text-card-container-2 .slick-dots li.slick-active button').removeAttr('aria-selected');
    },300)
    $('.image-with-text-card-container-2').on('afterChange', function(event, slick, currentSlide, nextSlide){
      setTimeout(function(){
        document.querySelectorAll('.image-with-text-card-container-2 .slick-slide').forEach(function (element) {
          const isHidden = element.getAttribute('aria-hidden') === 'true';
          element.setAttribute('tabindex', isHidden ? '-1' : '0');
        });
        if(slideDots.length > 0){
          for(let i=0; i<slideDots.length; i++){
            slideDots[i].setAttribute('role', 'button');
            slideDots[i].parentElement.classList.contains('slick-active') ? slideDots[i].setAttribute('aria-label', `Current slide ${i+1} of ${slideDots.length}`) : slideDots[i].setAttribute('aria-label', `Slide ${i+1} of ${slideDots.length}`);
          }
        }
        jQuery('.image-with-text-card-container-2 .slick-dots, .image-with-text-card-container-2 .slick-dots li').removeAttr('role');
        jQuery('.image-with-text-card-container-2 .slick-dots li.slick-active button').removeAttr('aria-selected');
      },300)
    });

    const $parent = jQuery('.image-with-text-card-container-2').parent();
    _theme.initSliderPlayPause($parent,jQuery('.image-with-text-card-container-2'),'Carousel slider');
    document.querySelectorAll('.image-with-text-card-container-2 .slick-slide').forEach(function (element) {
      element.blur();
    });
    $('.image-with-text-card-container-2').on('afterChange', function(event, slick, currentSlide){
      const $playPausebtn = $parent.find('.homepage-slider-play-pause button');
      let slidesToShow = slick.options.slidesToShow;
      if(currentSlide == slick.slideCount-Math.floor(slidesToShow)){
        $playPausebtn.addClass('active');
        $playPausebtn.attr('aria-label','Carousel slider play');
        jQuery('.image-with-text-card-container-2').slick('slickPause');
      }else{
        $playPausebtn.removeClass('active');
        $playPausebtn.attr('aria-label','Carousel slider pause');
        jQuery('.image-with-text-card-container-2').slick('slickPlay');
      } 
    });
  }

  _theme.initBlogSlider = function(section){
  const $container = section ? jQuery(section) : jQuery('.home-blog-posts-sections');
  const $blogGrid = $container.find('.custum-blog-slider');
  $blogGrid.slick(
    {
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      infinite: !1,
      responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.4,
          arrows:true,
          dots:false,
          slidesToScroll: 1,
        }
      }]
    }
    );
    setTimeout(function(){
      $blogGrid.find('.slick-slide').attr('tabindex', '-1');
    },1000)
    jQuery('.custum-blog-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
      setTimeout(function(){
        $blogGrid.find('.slick-slide').attr('tabindex', '-1');
      },1000)
    });
}
  if(jQuery('.over_location').length && _theme.isMobile) {
    const sliderSettings = {
      infinite: false,
      arrows:false,
      dots:false,
      slidesToShow: 1,
      autoplay:true,
      autoplaySpeed:4000,
      slidesToScroll: 1
    };

    inItLocationSlider(false);
    const $parent=jQuery('.over_location').parent()
    _theme.initSliderPlayPause($parent,jQuery('.over_location'),'Announcement bar slider');

    function inItLocationSlider(autoplay){
      if(autoplay){
        sliderSettings.autoplay = autoplay;
        sliderSettings.autoplaySpeed = 1000;
        sliderSettings.speed = 2000;
      }
      // if(screen.width < 768) sliderSettings.adaptiveHeight = true;
      if(jQuery('.over_location').hasClass('slick-initialized')){
        jQuery('.over_location').slick('unslick');
      }
      // jQuery('.over_location').on('beforeChange afterChange', function(event, slick, currentSlide, nextSlide){
      //   setTimeout(function() {
      //     slick.$slider.find('.slick-slide').removeAttr('tabindex aria-hidden');
      //   },100);
      //   setTimeout(function() {
      //     slick.$slider.find('.slick-slide').removeAttr('tabindex aria-hidden');
      //   },200);
      // });


      jQuery('.over_location').on('init', function(event, slick, currentSlide, nextSlide){
        slick.$slider.find('.slick-slide').removeAttr('tabindex aria-hidden');
        setTimeout(function() {
          slick.$slider.find('.slick-slide').removeAttr('tabindex aria-hidden');
        },100);
        setTimeout(function() {
          slick.$slider.find('.slick-slide').removeAttr('tabindex aria-hidden');
        },200);

        jQuery('.over_location p').each(function(){
          const txt = jQuery(this).text();
          if(!txt || jQuery(this).find('a').length === 0) return;
          jQuery(this).find('a').attr('aria-label', txt).removeAttr('title');
        });
      });
      jQuery('.over_location').slick(sliderSettings);
      $('.over_location').init(function(){
        $('.over_location').removeClass('opacity-none')
        $('.skelton-item').hide()
      }) 
    }
  }

  _theme.initSlickSlider(jQuery('.bogo-collection-slider .products-grid'), {
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    infinite: !1,
    speed: 300,
    responsive: [
    { breakpoint: 1300, settings: { slidesToShow: 4, slidesToScroll: 4 }},
    { breakpoint: 991, settings: { slidesToShow: 3, slidesToScroll: 3 }},
    { breakpoint: 767, settings: { slidesToShow: 1.5, arrows:true, slidesToScroll: 1}},
    { breakpoint: 370, settings: { slidesToShow: 1, arrows:true, slidesToScroll: 1, autoplay:true }},
  ]
    },function(slick){
      slick.$slider.find('.slick-slide').removeAttr('tabindex aria-hidden');
      slick.$slider.find('.slick-slide .smartwishlist').attr('tabindex', '-1');
      slick.$slider.find('.slick-slide.slick-active .smartwishlist').attr('tabindex', '0');
      setTimeout(function(){
        slick.$slider.find('.slick-slide').removeAttr('tabindex aria-hidden');
        slick.$slider.find('.slick-slide .smartwishlist').attr('tabindex', '-1');
        slick.$slider.find('.slick-slide.slick-active .smartwishlist').attr('tabindex', '0');
      }, 200);
  }, function(){
  });


  _theme.initSlickSlider(jQuery('.bon-vivant-section-wrap'), {
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    infinite: !1,
    speed: 300,
    responsive: [
    { breakpoint: 1300, settings: { slidesToShow: 2, slidesToScroll: 1 }},
    { breakpoint: 991, settings: { slidesToShow: 1, slidesToScroll: 1 }},

  ]
  });
  const $miniCartSlider = jQuery('.home-featured-products.cart-recommended-products .products-grid.new-products-grid');
  _theme.initSlickSlider($miniCartSlider, {
    dots: false,
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: 2.25,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: false,
          arrows: true,
          slidesToShow: 1.5,
          slidesToScroll: 1
        }
      }
    ]
    },function(){
      $miniCartSlider.on('afterChange', function(event, slick, currentSlide, nextSlide){
      slick.$slider.find('.slick-slide').removeAttr('tabindex');
      slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
      setTimeout(function(){
        slick.$slider.find('.slick-slide').removeAttr('tabindex');
      }, 1000);
      jQuery('.slick-slide').each(function(){
        if(jQuery(this).hasClass('slick-active')){
          jQuery(this).find('.smartwishlist').attr('tabindex','0');
        }
        else{
          jQuery(this).find('.smartwishlist').attr('tabindex','-1');
        }
      });
    });
  });
}

_theme.initFeaturedProductSlider = function(section){
  const $container = section ? jQuery(section) : jQuery('.home-featured-products');
  const $productGrid = $container.find('.feature-new-products-grid:not(.noSlider)');
  const $productItems = parseInt($productGrid.attr('data-row'));
  const $productDeskItems = $productItems - 1;
  const $productMidItems = $productItems - 2;
  if($productGrid.hasClass('slick-initialized')) $productGrid.slick('unslick');

  $productGrid.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    slickCb(slick);
  });

  $productGrid.on('afterChange', function(event, slick, currentSlide, nextSlide){
    slickCb(slick);
  });

  $productGrid.on('init', function(event, slick, currentSlide, nextSlide){
    slickCb(slick);
  });

  $productGrid.slick({
    rows:0,
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: $productItems,
    accessibility: true,
    slidesToScroll: 2,
    mobileFirst:true,
    responsive: [
      { breakpoint: 1500, settings: { slidesToShow: $productItems,slidesToScroll:2}},
      { breakpoint: 1200, settings: { slidesToShow: $productDeskItems,slidesToScroll:2}},
      { breakpoint: 991, settings: { slidesToShow: $productMidItems,slidesToScroll:2}},
      { breakpoint: 820, settings: { slidesToShow: 3,slidesToScroll:1 }},
      { breakpoint: 750, settings: { slidesToShow: 2.6,slidesToScroll:1 }},
      { breakpoint: 699, settings: { slidesToShow: 2.2,slidesToScroll:1 }},
      { breakpoint: 600, settings: { slidesToShow: 2,slidesToScroll:1 }},
      { breakpoint: 500, settings: { slidesToShow: 1.5, slidesToScroll:1 }},
      { breakpoint: 345, settings: { slidesToShow: 1.5, slidesToScroll:1 }},
      { breakpoint: 300, settings: { slidesToShow: 1, slidesToScroll:1 }},
      { breakpoint: 0, settings: { slidesToShow: 1, slidesToScroll:1 }}
    ]
  });

  setTimeout(function(){
    $productGrid.find('.slick-slide').attr('tabindex', '-1');
  },300)
    $productGrid.on('afterChange', function(event, slick, currentSlide, nextSlide){
    setTimeout(function(){
      slick.$slides.attr('tabindex', '-1');
    },300)
  });
  
  function slickCb(slick){
    slick.$slider.find('button.slick-arrow').attr('tabindex', 0);
    slick.$slider.find('button.slick-arrow[aria-disabled="true"]').attr('tabindex', -1);
    slick.$slider.find('.slick-slide:not(.slick-active)').attr('tabindex', -1);

    jQuery('.slick-slide').each(function(){
      if(jQuery(this).hasClass('slick-active'))
        jQuery(this).find('.smartwishlist').attr('tabindex','0');
      else
        jQuery(this).find('.smartwishlist').attr('tabindex','-1');
    });

    setTimeout(function(){
      slick.$slider.find('.slick-slide:not(.slick-active)').attr('tabindex', -1);
    }, 1000);
  }
}

_theme.initbestSellerProductSlider = function(section){
  const $container = section ? jQuery(section) : jQuery('.home-featured-products');
  const $productGrid = $container.find('.feature-collection-banner-products-grid');
  const $productItems = parseInt($productGrid.attr('data-row'));
  const $productDeskItems = $("body[data-template='collection.top-deals']")? $productItems: $productItems - 1;
  const $productMidItems = $productItems - 2;
  const $productBigScreen = $('body[data-template="page.reward-page"]')? $productItems:$productItems + 1;
  if($productGrid.hasClass('slick-initialized')) $productGrid.slick('unslick');

  $productGrid.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    slickCb(slick);
  });

  $productGrid.on('afterChange', function(event, slick, currentSlide, nextSlide){
    slickCb(slick);
  });

  $productGrid.on('init', function(event, slick, currentSlide, nextSlide){
    slickCb(slick);
  });

  $productGrid.slick({
    rows:0,
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: $productBigScreen,
    accessibility: true,
    slidesToScroll: 2,
    mobileFirst:true,
    responsive: [
      { breakpoint: 1700, settings: { slidesToShow: $productBigScreen,slidesToScroll:2}},
      { breakpoint: 1200, settings: { slidesToShow: $productDeskItems,slidesToScroll:2}},
      { breakpoint: 991, settings: { slidesToShow: $productMidItems,slidesToScroll:2}},
      { breakpoint: 820, settings: { slidesToShow: 1.5,slidesToScroll:1 }},
      { breakpoint: 750, settings: { slidesToShow: 1.4,slidesToScroll:1 }},
      { breakpoint: 699, settings: { slidesToShow: 1,slidesToScroll:1 }},
      { breakpoint: 600, settings: { slidesToShow: 2,slidesToScroll:1 }},
      { breakpoint: 500, settings: { slidesToShow: 1.5, slidesToScroll:1 }},
      { breakpoint: 345, settings: { slidesToShow: 1.5, slidesToScroll:1 }},
      { breakpoint: 300, settings: { slidesToShow: 1, slidesToScroll:1 }},
      { breakpoint: 0, settings: { slidesToShow: 1, slidesToScroll:1 }}
    ]
  });

  setTimeout(function(){
    $productGrid.find('.slick-slide').each(function () {
      const isHidden = $(this).attr('aria-hidden') === 'true';
      $(this).attr('tabindex', isHidden ? '-1' : '0');
  });
  },300)
    $productGrid.on('afterChange', function(event, slick, currentSlide, nextSlide){
    setTimeout(function(){
      slick.$slides.each(function () {
        const isHidden = $(this).attr('aria-hidden') === 'true';
        $(this).attr('tabindex', isHidden ? '-1' : '0');
      });
    },300)
  });
  
  function slickCb(slick){
    slick.$slider.find('button.slick-arrow').attr('tabindex', 0);
    slick.$slider.find('button.slick-arrow[aria-disabled="true"]').attr('tabindex', -1);
    slick.$slider.find('.slick-slide:not(.slick-active)').attr('tabindex', -1);

    jQuery('.slick-slide').each(function(){
      if(jQuery(this).hasClass('slick-active'))
        jQuery(this).find('.smartwishlist').attr('tabindex','0');
      else
        jQuery(this).find('.smartwishlist').attr('tabindex','-1');
    });

    setTimeout(function(){
      slick.$slider.find('.slick-slide:not(.slick-active)').attr('tabindex', -1);
    }, 1000);
  }
}




_theme.pushBackButton = (function(){

  function init(){
      const  pushBackButton = $('.backButtonMain')
      pushBackButton.off('click').on('click',function(e){
         e.preventDefault();
          _theme.Helpers.goToPreviousPage();
      })
   }
   return {init:init}
 })();
 

_theme.initHeaderEvetns = function(){
  if (jQuery(window).width() > 1199){
    setTimeout(function(){
      jQuery('.cm-mega-menu-filter-alpha .cm-mega-menu-alpha-cd.alpha-cd-a').click();
    }, 500);
  }

  var mob_dropdn = jQuery(".site-footer .dropdow-mb");
  if(_theme.isLaptopAndDown && mob_dropdn.length){
    mob_dropdn.off("click.slideToggle").on("click.slideToggle", function(evt) {
      evt.preventDefault();
      jQuery(this).next().stop().slideToggle();
      jQuery(this).toggleClass("open");
      "false" == jQuery(this).attr("aria-expanded") ? jQuery(this).attr("aria-expanded", "true") : jQuery(this).attr("aria-expanded", "false")
    });
  } else {
    mob_dropdn.next().css({display: ""});
  }

  jQuery('button.footer-pane-item.shopButton').click(function(e){
    handleMenuModal.call(this,e)
  });

  jQuery(document).on('click', '.wrapper-overlay,.mb-area-mob .close-mob-trig',function(e){
    e.preventDefault();
    e.stopPropagation();
    const isCloseButton = e.currentTarget && e.currentTarget.classList.contains('close-mob-trig');
    jQuery('.mb-area-mob .sub-menu-mobile').removeClass('sub-menu-open');
    jQuery('html').removeClass("translate-overlay");
    // jQuery('.mb-area-mob').removeClass('footerTargetMenu')
    jQuery(".toolbar .column-left .sidebar-label span").attr("aria-expanded", "false");
    jQuery(".close-menu-mb").removeClass("menu-open");
    // jQuery(".main-menu.jas-mb-style").css({overflow: ""});
    jQuery(".site-nav").find("[data-toggle-menu-mb]").parent().next(".sub-menu-mobile").removeClass("sub-menu-open");
    jQuery('.wrapper-overlay').addClass('active');
    jQuery(".hamburger-icon .icon-nav").attr("aria-expanded", "false");
    jQuery(".close-menu-mb").removeClass("menu-open");
    if($('.transcript-modal')){
      $('.transcript-modal').removeClass('active');
    }
    _theme.toggleSideCart(false, null, !isCloseButton);

     if(_theme.isLaptopAndDown) {
      $('.mb-area-mob').closest('#shopify-section-navigation').siblings().removeAttr('aria-hidden');
      jQuery('.mb-area-mob').addClass('dualNav')
      jQuery('.mb-area-mob').css({"overflow": ""})
    }
    jQuery('.footer-pane-item.shopButton').focus();
  });

  jQuery(document).on('click', '[data-toggle-menu-mb]', handleSubmenuTrigger);

  jQuery('.images-two img').attr('aria-hidden', true);
  jQuery('header-search .images-two img').removeAttr('aria-hidden');
  jQuery('[data-template="page.reward-page"] .images-two img').removeAttr('aria-hidden');

  function handleMenuModal(e){
    e.preventDefault();
    e.stopPropagation();
    jQuery('html').toggleClass("translate-overlay");
    jQuery('.mb-area-mob').find('*').removeAttr('aria-hidden')

    jQuery(".close-menu-mb").toggleClass("menu-open");
    // jQuery(".main-menu.jas-mb-style").css({overflow: ""});
    jQuery(".site-nav").find("[data-toggle-menu-mb]").parent().next(".sub-menu-mobile").removeClass("sub-menu-open");
      // document.activeElement.blur();

      setTimeout(function(){
        _theme.focusTrap(jQuery('.mb-area-mob nav.nav-bar'), function(){
          jQuery('.mb-area-mob button.close-mob-trig').click()
        });
      }, 250);
      if(_theme.isLaptopAndDown) {
        e.target.setAttribute('aria-expanded','true')
        jQuery('.mb-area-mob').closest('#shopify-section-navigation').siblings().attr({'aria-hidden':'true'})
      }
  }

  function handleSubmenuTrigger(evt){
    evt.preventDefault();
    // evt.stopPropagation();
    // evt.stopImmediatePropagation();
    if(jQuery(window).width() > 1199){
      handleDesktopMegaMenu.call(this, evt);
    } else {
      handleMobileMegaMenu.call(this, evt);
    }
  }


  function handleDesktopMegaMenu(evt){
    const $self =jQuery(this);
    const $parent =jQuery(this).closest('li.menu-lv-1');
    $parent.toggleClass('active').siblings('li').removeClass('active');
    const attr =jQuery(this).attr('aria-expanded') || false;
    const $submenu = $self.next('.sub-menu-mobile');
    jQuery(this).attr('aria-expanded', !JSON.parse(attr));

    setTimeout(() => {
      // _theme.focusTrap($submenu, function(){
      //   $parent.removeClass('active');
      //   $self.focus();
      //   $self.attr('aria-expanded', false);
      // });

      $submenu.off('keydown').on('keydown', function(evt){
        if(evt.key === 'Escape'){
          $parent.removeClass('active');
          $self.focus();
          $self.attr('aria-expanded', false);
        }
      });

      $submenu.off('focusout').on('focusout', function(evt){
        if(evt.relatedTarget && !$submenu[0].contains(evt.relatedTarget)){
          $parent.removeClass('active');
          $self.attr('aria-expanded', false);
        }
      });
    }, 250);
  }

  function handleMobileMegaMenu(evt){
    const $self = jQuery(this);
    var expand = jQuery(this).attr('aria-expanded') || false;
    expand = JSON.parse(expand);
    jQuery(this).attr('aria-expanded', !expand);
    var $menu = jQuery(this).next(".sub-menu-mobile");
    if($menu.length === 0) $menu = jQuery(this).parent().find(".sub-menu-mobile").first();
    const isOpen = $menu.hasClass("sub-menu-open");
    if(isOpen){
      $menu.removeClass("sub-menu-open");
      jQuery('.mb-area-mob').css({"overflow-y": "auto"});
      $menu.attr('aria-hidden','true');
      $('*').not($('.sub-menu-open').find('*')).not('.sub-menu-open').not('cart-offer-list').not($('.sub-menu-open').parents()).removeAttr('aria-hidden','true');
    } else {
      $menu.removeClass("sub-menu-open");
      $menu.addClass("sub-menu-open").css({overflow: ""});
      jQuery('.mb-area-mob').css({overflow: "hidden"});
      $menu.attr('aria-hidden','false');
      $('*').not($('.sub-menu-open').find('*')).not('.sub-menu-open').not('cart-offer-list').not($('.sub-menu-open').parents()).attr('aria-hidden','true');
    }

    jQuery(this).animate({ scrollTop: 0}, 0);
    jQuery(this).css({ overflow: "hidden" });

    if(_theme.isLaptopAndDown) {
      // $self.closest('.menu-lv-1').siblings().attr('aria-hidden','true');
      $self.closest('.sub-menu-mobile').find('.menu-col-banner').attr('aria-hidden','true');
      $self.closest('[data-griditem]').siblings().attr('aria-hidden','true');

    }

    setTimeout(function(){
      _theme.focusTrap($menu, function(){
        $menu.removeClass('sub-menu-open');
        $self.attr('aria-expanded', false);
        $self.focus();
      });
    }, 250);
  }
  
  jQuery('.desktop-navigation-wrap .cm-mega-menu-alpha-cd').on('keyup', function(evt){
    _theme.handleKeyboardEnterOrSpacePress(evt, true);
  });

  jQuery(document).on('click', '.cm-mega-menu-alpha-cd',function(evt){
    jQuery(this).addClass('active').siblings().removeClass('active');
    jQuery(this).attr('aria-pressed','true').siblings().attr('aria-pressed','false');
    jQuery('.cm-mega-menu-tp-1-menu').removeClass('show-area');
    jQuery('.cm-mega-menu-filter-content').addClass('show-area');
   
    let letter = jQuery(this).data('letter');
    if(!letter) return;
    letter = letter.toLowerCase().trim();
    if(_theme.isLaptopAndDown) {
      jQuery('.go-back-ttl-a-z-t').attr('data-letter', letter).text(letter);
    }
    else jQuery('.go-back-ttl-a-z-t').text('');
    let list = '';
    _theme.vendors.map(function(brand){
      const first_letter = brand.substr(0, 1).toLowerCase().trim();
      if(letter === first_letter){
        list += '<li class="show-filter-li"><a aria-label="'+brand+'" href="/collections/'+ _theme.Helpers.handleize(brand) +'">'+ brand +'</a></li>';
      }
    });
   
    jQuery('[data-header-brands-list]').empty().html(list);
    if(_theme.isLaptopAndDown){
      setTimeout(() => {
        _theme.focusTrap(jQuery('.mb-area-mob .cm-mega-menu-filter-content'), function(elem, e){
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();
          jQuery('.mb-area-mob .go-back-ttl-a-z-t').click();
        });
      }, 250);
    }
  });

  jQuery(document).on('click', '.cm-mega-menu-filter-title strong',function(){
    jQuery('.cm-mega-menu-tp-1-menu').addClass('show-area');
    jQuery('.cm-mega-menu-filter-content').removeClass('show-area');
    jQuery('.cm-mega-menu-alpha-cd').removeClass('active');
    jQuery('.cm-mega-menu-filter-content li').removeClass('show-filter-li');
  });

  if(jQuery(window).width() > 1199){jQuery('.site-nav .no-mega-menu .sub-menu-mobile').remove()}

  jQuery('.site-nav-dropdown a span').each(function(){
    let txt = jQuery(this).text();
    let clas = txt.toLowerCase().replaceAll(' ','_');
    jQuery(this).parent('a').addClass(clas);
  });

}

_theme.initNavigationEvents = function(){
  jQuery('body .mb-area-mob .site-nav .menu-mb-title .close-mob-trig, body .mb-area-mob .site-nav .mega-menu .menu-lv-2 .menu-mb-title .close-mob-trig').remove();
  jQuery('body .mb-area-mob .site-nav .menu-mb-title, body .mb-area-mob .site-nav .mega-menu .menu-lv-2 .menu-mb-title').append('<button class="close-mob-trig"><img src="https://cdn.shopify.com/s/files/1/0910/0818/files/icon-close-black.png?v=1726667795" alt="Close"></button>');
  // this belongs to back btton
  jQuery('body .mb-area-mob .site-nav .menu-mb-title button.icon-dropdown').click(function(e){
    const isNestedMenu = $(this).parents('.sub-menu-mobile').length > 1 ? true : false;
    jQuery(this).parent().parent().parent('.sub-menu-mobile').removeClass('sub-menu-open');
    jQuery(this).parent().parent('.sub-menu-mobile').removeClass('sub-menu-open');
    if(isNestedMenu){
      jQuery('.mb-area-mob').css({overflow: "hidden"});
    } else {
      jQuery('.mb-area-mob').removeAttr('style');
    }
    e.stopPropagation();
  });
  jQuery('.mb-area-mob span.close-mob-trig').click(function(e){
    jQuery('html').removeClass('translate-overlay');
    jQuery('.mb-area-mob').find('*').attr('aria-hidden','true')
      jQuery('.sub-menu-mobile').removeClass('sub-menu-open');
      jQuery('.cm-mega-menu-filter-content').removeClass('show-area');
      jQuery('.mb-area-mob').removeAttr('style');
      e.stopPropagation();
  });
  jQuery('span.go-back-ttl').click(function(e){
      jQuery(this).parent().parent('.cm-mega-menu-dl-back').removeClass('sub-menu-open');
      e.stopPropagation();
  });
  jQuery('button.a-z-back-btn').click(function(e){
      const parent = this.closest('.cm-mega-menu-filter-menu');
      const brandBtn = parent.parentElement.querySelector('.cm-mega-menu-filter-title-mob');
      parent.classList.remove('sub-menu-open');
      if(brandBtn) {
        brandBtn.focus();
        brandBtn.setAttribute('aria-expanded', false);
      }
      jQuery('.mb-area-mob').removeAttr('style');
      e.stopPropagation();
  });
  jQuery('.go-back-ttl-a-z-t').click(function(e){
    e.stopPropagation();
    const letter = jQuery(this).attr('data-letter');
    jQuery(this).parent().parent('.cm-mega-menu-filter-content').removeClass('show-area');
    jQuery(this).closest('.site-nav-dropdown').find('.cm-mega-menu-alpha-cd[data-letter="'+letter+'"]').focus();
  });
  jQuery('body .mb-area-mob .site-nav .mega-menu .menu-lv-2 button.icon-dropdown').click(function(e){
     jQuery(this).parent().next().addClass('sub-menu-open');
  });

  const brandBtns = document.querySelectorAll('.mb-area-mob .sub-menu-mobile .cm-mega-menu-filter-title-mob');
  brandBtns.forEach(btn => {
    btn.addEventListener('click', evt => {
      if(!btn.nextElementSibling) return;
      btn.setAttribute('aria-expanded', true);
      btn.nextElementSibling.classList.add('sub-menu-open');
    });
  });
}

_theme.initShopByBrand = function(){
  var brandSlider1_arrow = false;
  var $brandsLoadMore = jQuery('.logo-brand #load-brands');
  var $itemWrapper = jQuery('.logo-brand .brands-slider1');
  if(jQuery('.brands-slider1 > .item').length > 6){
    brandSlider1_arrow = true;
  }

  $itemWrapper.slick({
    infinite: false,
    arrows: brandSlider1_arrow,
    dots: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true

        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.4,
          slidesToScroll: 1,
          arrows: true
        }

      },
      {
      	breakpoint: 767,
      	settings: 'unslick',
      }
    ]
  });


  var perLoad = 6;
  var block_loaded = 6;
  var totalBlocks = Number($itemWrapper.attr('data-blockcount'));
  if(totalBlocks > perLoad){
    $brandsLoadMore.click(function(evt){
		block_loaded += perLoad;
        if(block_loaded >= totalBlocks){
          block_loaded = totalBlocks;
          jQuery(this).remove();
        }
      	var $lastChild = $itemWrapper.find('.item:nth-child('+ (block_loaded) +')');
      	$lastChild.addClass('active').prevAll().addClass('active');
    });
  }
}

_theme.removeElements = function(){
  if(!_theme.isLaptopAndUp){
    var headerPanelTop = document.querySelector('.wrapper-header-bt .header-pc .header-panel-top');
    var headerFindStore = document.querySelector('.header-top .top-message .find-a-store.header-top-bar');
    headerPanelTop && headerPanelTop.remove();
    headerFindStore && headerFindStore.remove();
    jQuery(".header-top .top-message .find-a-store.header-top-bar ").remove(),
    jQuery(".wrapper-header-bt .header-pc .header-panel-top").remove();
  }
  if(_theme.isLaptopAndDown){
    jQuery("footer .foot-title.dropdow-mb").each(function(index, item) {
      const newElem = '<button type="button" aria-expanded="false" class="'+ $(this).attr('class') +'">' + this.innerHTML + '</button>';
      jQuery(this).replaceWith(jQuery(newElem));
    });
    jQuery('.mb-area-mob .site-nav-desktop [data-toggle-menu-mb]').attr({
      'tabindex': 0,
      'aria-hidden': 'false'
    });
    jQuery( "footer.footer-wrapper .footer-pane" ).insertAfter( jQuery( "footer.footer-wrapper  .site-footer-inner" ));
  } else {
    jQuery("h3.foot-title.dropdow-mb").removeAttr("tabindex");
    jQuery('.mb-area-mob .site-nav-desktop [data-toggle-menu-mb]').attr({
      'tabindex': -1,
      'aria-hidden': true
    });
  }
}

_theme.initChatWidget = function () {
  if(jQuery(window).width() < 768){
    LiveChatWidget.call("hide");
    function onVisibilityChanged(data) {
      switch (data.visibility) {
        case "maximized":
          break;
        case "minimized":
          LiveChatWidget.call("hide");
          break;
        case "hidden":
          break;
      }
    }

    LiveChatWidget.on('visibility_changed', onVisibilityChanged)
  }

  $(document).on('click', '.btn-chat', function () {
    LiveChatWidget.call("maximize");
  });
  $('.btn-chat').keypress(function(event) {
    if (event.which === 13) {
      event.preventDefault();
      LiveChatWidget.call("maximize");
    }
  });
  $(document).on('click', '.footer-pane-item.support-chat', function () {
    LiveChatWidget.call("maximize");
  });

  var chats = document.querySelectorAll('[data-chat-toggle]');
  chats.forEach(function (chat) {
    chat.addEventListener('click', function (evt) {
      evt.preventDefault();
      window.LiveChatWidget.call("maximize");
    });
  });

  function onAvailabilityChanged(data) {
    if (data.availability === "online") {
      var elementSup = document.querySelector('.footer-pane-grid .footer-pane-item.support-chat .small-des');
      if (elementSup) {
        elementSup.textContent = 'Chat';
      }
    } else {
      var elementChat = document.querySelector('.footer-pane-grid .footer-pane-item.support-chat .small-des');
      if (elementChat) {
        elementChat.textContent = 'Support';
      }
    }
    jQuery('.footer-pane-item.support-chat .icon,.footer-pane-item.support-chat .content').removeClass('hide');
    jQuery('.footer-pane-item.support-chat .footer-pane-loader').addClass('hide');
  }

  LiveChatWidget.on('availability_changed', onAvailabilityChanged);
}

_theme.initAccessibility = function(){
  document.querySelector('.footer-pane-item.accessbility').addEventListener('click',function(){
    document.querySelector('.acsb-trigger.acsb-trigger-size-medium').click()
  })
  function checkadbsExist(){
    if(jQuery('.acsb-actions-active').length){
      jQuery('.footer-pane-item.accessbility .active_accessbility').removeClass('hide');
      jQuery('.footer-pane-item.accessbility').addClass('blue');
      jQuery('.footer-pane-item.accessbility ._accessbility').addClass('hide');
    }else{
      jQuery('.footer-pane-item.accessbility').removeClass('blue');
      jQuery('.footer-pane-item.accessbility .active_accessbility').addClass('hide');
      jQuery('.footer-pane-item.accessbility ._accessbility').removeClass('hide');
    }
  }
  jQuery('.footer-pane-item.accessbility .icon,.footer-pane-item.accessbility .content').removeClass('hide');
  jQuery('.footer-pane-item.accessbility .footer-pane-loader').addClass('hide');
  jQuery(window).on('load',function(){
    setTimeout(function(){
      checkadbsExist();
    },700)
  })
  jQuery(document).on('click','[data-acsb-option="close"]',function(){
    checkadbsExist()
  })
}

_theme.loadAppScript = function(){
  if(!_theme.appsScripts || _theme.appsScripts.length === 0) return;
  
  const initLiveChat = _theme.settings.livechat_enable && _theme.settings.livechat_type === 'default';

  const criticalScripts = _theme.appsScripts.filter(function(script_src){
    let status = false;
    if(script_src.indexOf('bazaarvoice') > -1) status = true;
    if(script_src.indexOf('searchanise') > -1) status = true;
    if(script_src.indexOf('searchserverapi') > -1) status = true;
    if(script_src.indexOf('klarna') > -1) status = true;
    if(script_src.indexOf('wiser.expertvillagemedia.com') > -1) status = true;
    if(script_src.indexOf('smartwishlist.webmarked.net') > -1) status = true;
    if(script_src.indexOf('services.nofraud.com') > -1) status = true;
    if(script_src.indexOf('crazyegg') > -1) status = true;
    if(script_src.indexOf('signifyd') > -1) status = true;

    if(script_src.indexOf('d10lpsik1i8c69.cloudfront.net') > -1) status = false; // loading on <head> "head-app-script.liquid" file
    return status;
  });
  
  const nonCriticalScripts = _theme.appsScripts.filter(function(script_src){
    let status = true;
    if(script_src.indexOf('bazaarvoice') > -1) status = false;
    if(script_src.indexOf('searchanise') > -1) status = false;
    if(script_src.indexOf('searchserverapi') > -1) status = false;
    if(script_src.indexOf('klarna') > -1) status = false;
    if(script_src.indexOf('wiser.expertvillagemedia.com') > -1) status = false;
    if(script_src.indexOf('smartwishlist.webmarked.net') > -1) status = false;
    if(script_src.indexOf('services.nofraud.com') > -1) status = false;
    if(script_src.indexOf('crazyegg') > -1) status = false;
    if(script_src.indexOf('signifyd') > -1) status = false;

    if(script_src.indexOf('d10lpsik1i8c69.cloudfront.net') > -1) status = false; // loading on <head> "head-app-script.liquid" file
    return status;
  });

  criticalScripts.map(function(s){appendScript(s)});

  let script_loaded = false;
  window.ju_num="DD47F4B7-E44F-41C6-8126-66D05527DD9C";window.asset_host='//cdn.jst.ai/';(function(i,s,o,g,r,a,m){i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)};a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script',asset_host+'vck.js','juapp');
  _theme.handleADA();
  document.addEventListener('scroll', loadScriptOnScroll);

  function loadScriptOnScroll(){
    if(window.pageYOffset > 50 && !script_loaded){

      script_loaded = true;
      nonCriticalScripts.map(function(s){appendScript(s)});
      window.$ = window.jQuery;
      setTimeout(function(){window.$ = window.jQuery;}, 3000);
      setTimeout(function(){window.$ = window.jQuery;}, 6000);
      document.removeEventListener('scroll', loadScriptOnScroll)
    }
  }

  function appendScript(script_url){
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true; // s.defer = 'defer';
    s.src = script_url;
    var x = document.getElementsByTagName('script')[0];
    x.parentNode.insertBefore(s, x);
  }

  if(_theme.isMobile && initLiveChat) _theme.initChatWidget();

  delete _theme.appsScripts;
}

_theme.initGTM = function(){
  window.dataLayer = window.dataLayer || [];
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.onload = () => {
    dataLayer.push({ event: 'gtm.js', 'gtm.start': new Date().getTime(), 'gtm.uniqueEventId': 0 });
  }; // this part ensures PageViews is always tracked
  script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-PCB328B';
  document.head.appendChild(script);
}

_theme.loadSection = function(){
  const fcp = document.querySelector('.fcp');
  fcp && fcp.remove();

  const sections = document.querySelectorAll('.section--async');
  if(sections.length === 0) return;
  let viewportHeight = Math.floor(window.innerHeight - ((window.innerHeight*1)/100)) + 'px';

  let observer = new IntersectionObserver(function(entries, observer){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        let section = entry.target;
        try{
          const section_json = JSON.parse(section.querySelector('[data-section-script]').textContent);
          section.classList.add('loaded');
          section.innerHTML = section_json.html;
          if(section_json.type === 'home_featured_products'){
            loadFeaturedProductsEvents(section);
            const bannerLink = section.querySelector('.image-with-text-card-item-link');
            if(bannerLink && _theme.track) _theme.track.trackView(bannerLink.getAttribute('aria-label') || "For Her/Him");
          }
          if(section_json.type === 'home_blog'){
            _theme.initBlogSlider(section);
          }
          if(section_json.type === 'icons_wrapper'){
            const trustpilot = document.querySelector('trustpilot-summary');
            if(trustpilot) {
              trustpilot.repaintContent();
            }
          }

        } catch(err){
          console.log('Error', err)
        }
        observer.unobserve(section);
      }
    });
  }, {
      root: null,
      rootMargin: '0px 0px '+ viewportHeight +' 0px',
      threshold: 0.05
    });

  sections.forEach(function(section){
    observer.observe(section);
  });

  function loadFeaturedProductsEvents(section){
    _theme.initFeaturedProductSlider(section);
    _theme.initbestSellerProductSlider(section);
    _theme.initSmartWishlist();
  }
}

_theme.initLazyloadData = function(){
  const sections = document.querySelectorAll('[data-async]');
  if(sections.length === 0) {
    _theme.initNavigationEvents();
    return;
  }


  sections.forEach(function(section){
    try{
      const section_json = JSON.parse(section.querySelector('[data-section-script]').textContent);
      section.innerHTML = '';
      section.innerHTML = section_json.html;
    } catch(err){
    }
  });
   _theme.initNavigationEvents();
}

_theme.redemptionPopup = function(){
  if(jQuery('.redemption-popup').length === 0) return;
  if(_theme.Helpers.getCookie('redemtion_popup') == ''){
    setTimeout(function(){
      var d = new Date();
      d.setTime(d.getTime() + (3600 * 1000 * 24 * 365 * 1));
      let expires = "expires="+ d.toUTCString();
      document.cookie = 'redemtion_popup' + "=" + 'expire_value' + ";" + expires;
      jQuery('.redemption-popup').find('[data-redemption-content]').attr('tabindex', 0);
      // jQuery('.redemption-popup').addClass('active').find('.title').focus();
      jQuery('.redemption-popup').addClass('active').focus();
    },1000*60)
  }
  jQuery(document).on('click','.redemption-popup .close-popup',handleClosePopup);
function handleClosePopup(){
    jQuery('.redemption-popup').find('[data-redemption-content]').attr('tabindex', -1);
    jQuery('.redemption-popup').removeClass('active');
    jQuery(document).off('click','.redemption-popup .close-popup',handleClosePopup);
  }
}

_theme.initMobileEvents = function(unload){
  const mobileMenu = document.querySelector('.mb-area-mob');
  if(!mobileMenu) return;
  if(unload){
    mobileMenu.removeEventListener('focusout', menuHandleFocusOut);
  } else {
    mobileMenu.addEventListener('focusout', menuHandleFocusOut);
  }

  function menuHandleFocusOut(){
    if(!this.contains(document.activeElement)){
      jQuery('.mb-area-mob .close-mob-trig').click();
    }
  }
}

_theme.updateDOMOnResize = function(){
  window.onresize = debounce(function(){
    if(_theme.isIpadAndUp){
      // _theme.initMobileEvents(1);
      if(window.LiveChatWidget) LiveChatWidget.call("minimize");
      jQuery('.mb-area-mob .site-nav-desktop [data-toggle-menu-mb]').attr({
        'tabindex': -1,
        'aria-hidden': 'true'
      });
      jQuery( "footer.footer-wrapper .footer-pane" ).insertBefore( jQuery( "footer.footer-wrapper .site-footer-inner" ));
    } else {
      // _theme.initMobileEvents();
      if(window.LiveChatWidget) LiveChatWidget.call("hide");
      jQuery('.mb-area-mob .site-nav-desktop [data-toggle-menu-mb]').attr({
        'tabindex': 0,
        'aria-hidden': 'false'
      });
      jQuery( "footer.footer-wrapper .footer-pane" ).insertAfter( jQuery( "footer.footer-wrapper .site-footer-inner" ) );
    }
  });
}

_theme.ProductGridQuickView = (function(){
  let cacheQuickview = {};
  let activeId = null;
  let timer;
  let collection;

  function init(){
    jQuery('[data-quickview-modal]').click(function(evt){
      const isInside = jQuery(evt.target).closest('.halo-modal-content').length ? true : false;
      if(!isInside) {
        jQuery(this).fadeOut();
        emptyQV();
        if(activeId){
          jQuery('.product-item[data-product-id="'+activeId+'"] .quickview-button').focus();
          activeId = null;
        }
      }
    });

    jQuery(".close-modal").click(function(){
      jQuery(".ajax-success-modal.halo-modal.ajax-quickview").hide();
      emptyQV();
      if(activeId){
        jQuery('.product-item[data-product-id="'+activeId+'"] .quickview-button').focus();
        activeId = null;
      }
      document.querySelector('body').classList.remove('quickview_active');
    });

    if(!_theme.isIpad){
      jQuery(document).off('mouseenter', '.product-item .quickview-button').on('mouseenter', '.product-item .quickview-button', function(evt){
        timer = setTimeout(() => {
          _theme.track.trackView("Quickview");
        }, 300);
      });
  
      jQuery(document).off('mouseleave', '.product-item .quickview-button').on('mouseleave', '.product-item .quickview-button', function(evt){
        clearTimeout(timer);
      });
    }

    jQuery(document).off('click', '.coll-3-for-99.grid-item .product-item').on('click', '.coll-3-for-99.grid-item .product-item', function(evt){
      if(evt.type !== 'click') return;
      
      const target = evt.target;
      const parent = evt.target.closest('.coll-3-for-99.grid-item');
      const atcBtn = parent.querySelector('button.cm-add-bndle-pro');
      const qvDeskBtn = parent.querySelector('.quickview-button');
      const qvMObButton = parent.querySelector('button[data-sidecartqv]');
      const wishlist = parent.querySelector('.smartwishlist');
      const clickedInMainArea = [atcBtn, qvDeskBtn, qvMObButton, wishlist].some(node => node && node.contains(target));
      if(clickedInMainArea) return;

      if(window.screen.width >= 992){
        qvDeskBtn.click();
      }else{
        qvMObButton.click();
      }
    });

    jQuery(document).off('click', '.product-item .quickview-button').on('click', '.product-item .quickview-button', async function(evt){
      evt.preventDefault();
      activeId = jQuery(this).closest('.product-item').attr('data-product-id');
      const handle = jQuery(this).data('id');
      collection = jQuery(this).closest('.product-item').attr('collection');
      let var_id = this.dataset.varId;

      let vid = jQuery(this).closest('.product-item').attr('data-vid');;
    
      if(!handle) return;

      _theme.track.trackClick('Quickview');

      if(cacheQuickview[handle]){
        showQV(cacheQuickview[handle].html);
      } else {
        try {
          _theme.toggleLoading(1);
          const resp = await fetch("/products/" + handle + `?view=quickview${'&collection='+collection}${'&variant=' + (var_id ? var_id : vid)}`);
          const text = await resp.text();
          cacheQuickview[handle] = { html: text };
          showQV(text, activeId);
          _theme.toggleLoading();
        } catch(err){
          _theme.toggleLoading();
          _theme.toggleAjaxModal(1, err.message || "Something went wrong");
        }
      }
    });
  }

  function showQV(res,activeId){
    emptyQV();
    const body = _theme.Helpers.stringToHTML(res);
    jQuery('[data-quickview-modal] .halo-modal-body').empty().html(
      jQuery(body).find('.product-wrapper').html()
    );
    jQuery('[data-quickview-modal]').attr('data-source', activeId).fadeIn();
    Shopify.PaymentButton && Shopify.PaymentButton.init();
    // if(jQuery('.product__title').is(':visible')) {
    //   jQuery('.product__title').attr('id','qv_label');
    //   jQuery('[data-quickview-modal]').attr('aria-labelledby', 'qv_label');
    // }
    _theme.initSmartWishlist();
    _theme.handleWishlistChange();
    _theme.focusTrap(jQuery('.ajax-success-modal.halo-modal.ajax-quickview'),function() {
      jQuery('.ajax-quickview .close-modal').click();
    });
    _theme.Helpers.refreshKlarna();
    document.querySelector('body').classList.add('quickview_active');
  }
  function emptyQV(){
    jQuery('[data-quickview-modal] .halo-modal-body').empty();
  }

  return {init: init}
})();

_theme.Wishlist = (function(){
  const WISHLIST_KEY = 'wishListsArr';
  let wishlist_arr = null;

  function init(){
    jQuery('[data-icon-wishlist]').off('click').on('click touchend', function(evt){
      evt.preventDefault();
      if(!_theme.settings.customer){
        jQuery(".cm-log-in-form").css("display", "block").addClass("show");
    }
      const $self = jQuery(this);
      wishlist_arr = getWishlistHandles() || [];
      const handle = $self.data('product-handle');
      const item_index = wishlist_arr.indexOf(handle);
      const isAdded = $self.hasClass("whislist-added") ? true : false;
      const p_id = $self.data('id');
      if(item_index !== -1 && isAdded) removeProductFromWishlist(handle,p_id,$self);
      else addProductToWishlist(handle, $self);
    });

    if(jQuery("body.template-page [data-wishlist-container]").length){
      initWishlistProductGrid();
    }
    updateWishlistStatus();
  }

  function updateWishlistStatus(title){
    wishlist_arr = getWishlistHandles();
    if(!wishlist_arr) return;
    wishlist_arr.map(function(handle){
      var a = jQuery('[data-product-handle="' + handle + '"]');
      a.addClass("whislist-added");
      let prefix = title ? title : a.data('title') ?  a.data('title') : '';
      prefix = prefix ? prefix : a.closest(".product-item").find(".product-title span").text();
      prefix = prefix ? prefix : '';
      jQuery("body").hasClass("template-product") ? a.attr("aria-label", prefix + ' ' +window.inventory_text.remove_wishlist) : a.attr("aria-label", "Remove to Wishlist of " + a.closest(".product-item").find(".product-title span").text() + " ");
      a.find(".wishlist-text").text(window.inventory_text.remove_wishlist);
    });
  }

  function initWishlistProductGrid(){
    wishlist_arr = getWishlistHandles();
    if(!wishlist_arr) return;
    _theme.toggleLoading(1);
    const placeholder_index = wishlist_arr.indexOf("[[Product_Handle]]");
    if(placeholder_index > -1) wishlist_arr.splice(placeholder_index,1);
    const temp_arr = wishlist_arr.concat([]);
    const products = [];
    fetchData();
    function fetchData(){
      if(temp_arr.length){
        const handle = temp_arr.shift();
        fetch('/products/' + handle + '.js').then(function(res){
          return res.json()
        }).then(function(res){
          products.push(res);
          fetchData();
        }).catch(function(err){
          console.log(err);
        });
      } else {
        if(products.length){
          jQuery('.wishlist-page').removeClass('wishlist--empty');
          products.map(function(p){
            buildWishlistProductGrid(p);
          });
          initWishlistProductGridEvents();
        } else {
          jQuery('.wishlist-page').addClass('wishlist--empty');
        }
        _theme.toggleLoading();
      }
    }
  }

  function initWishlistProductGridEvents(){
    jQuery(document).off('click', '[data-btn-addtocart]').on('click', '[data-btn-addtocart]',function(evt){
      evt.preventDefault();
      const vid = jQuery(this).closest('form').find('[name="id"]').val();
      if(!vid) return;
      const $self = this;
      jQuery(this).closest('[data-wishlist-container]').addClass('processing');
      _theme.toggleLoading(1);

      _theme.Helpers.addProductToCart(vid,1, null, function(resp){
        _theme.MiniCart.lineItemChangeCallBack(resp, function(){
          _theme.toggleLoading();
          jQuery('[data-wishlist-container]').removeClass('processing');
          _theme.toggleSideCart(1, $self, true);
        });
      });
    });
  }

  function buildWishlistProductGrid(t){
    if(!t) return;
    const $wishlistContainer = jQuery("[data-wishlist-container]");
    var e = "", i = Shopify.formatMoney(t.price_min, window.money_format);
    e += '<div class="grid-item" data-wishlist-added="wishlist-' + t.id + '">',
    e += '<div class="inner product-item" data-product-id="product-' + t.handle + '">',
    e += '<div class="column col-img"><div class="product-image">',
    e += '<div class="product-grid-image" data-collections-related="/collections/all?view=related">',
    e += '<img src="' + t.featured_image + '" alt="' + t.featured_image.alt + '">',
    e += "</div></div></div>",
    e += '<div class="column col-prod">',
    e += '<div class="product-vendor">',
    e += '<a href="/collections/vendors?q=' + t.vendor + '" title="' + t.vendor + '">' + t.vendor + "</a></div>",
    e += '<a class="product-title" href="' + t.url + '" title="' + t.title + '">' + t.title + "</a></div>",
    e += '<div class="column col-price text-center"><div class="p-price">' + i + "</div></div>",
    e += '<div class="column col-remove text-center"><a class="whislist-added" href="#" data-product-handle="' + t.handle + '" data-icon-wishlist data-id="' + t.id + '"><svg class="closemnu" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 357 357" xml:space="preserve"><g><g><polygon points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3 214.2,178.5"></polygon></g></g></svg></a></div>',
    e += '<div class="column col-options text-center">',
    e += '<form action="/cart/add" method="post" class="variants" id="-' + t.id + '" data-id="product-actions-' + t.id + '" enctype="multipart/form-data">',
    t.available ? (1 == t.variants.length && (e += '<button data-btn-addToCart class="btn add-to-cart-btn" type="submit" data-form-id="#-' + t.id + '" >' + window.inventory_text.add_to_cart + '</button><input type="hidden" name="id" value="' + t.variants[0].id + '" />'),
    t.variants.length > 1 && (e += '<a class="btn" title="' + t.title + '" href="' + t.url + '">' + window.inventory_text.select_options + "</a>")) : e += '<button data-btn-addToCart class="btn add-to-cart-btn" type="submit" disabled="disabled">' + window.inventory_text.unavailable + "</button>",
    e += "</form></div>",
    e += "</div></div>",
    $wishlistContainer.append(e);
  }

  function addProductToWishlist(handle, $self, callback){
    if(!handle) return;
    const title = $self.data('title');
    wishlist_arr = getWishlistHandles() || [];
    const item_index = wishlist_arr.indexOf(handle);
    if(item_index !== -1) return;
    wishlist_arr.push(handle);
    $self.addClass("whislist-added");
    $self.find(".wishlist-text").text(title +' '+ window.inventory_text.remove_wishlist);
    $self.find('[data-aria-live]').text('Added to wishlist');
    // $self.attr("aria-label", window.inventory_text.remove_wishlist);
    saveWishlistProducts();
    updateWishlistStatus(title);
    if(callback && typeof callback === 'function') callback();
  }

  function removeProductFromWishlist(handle, p_id, $self, callback){
    if(!handle) return;
    wishlist_arr = getWishlistHandles();
    if(!wishlist_arr) return;
    const title = $self.data('title');
    const item_index = wishlist_arr.indexOf(handle);
    if(item_index === -1) return;
    wishlist_arr.splice(item_index, 1);
    $self.removeClass("whislist-added");
    $self.find(".wishlist-text").text(window.inventory_text.add_wishlist);
    $self.attr("aria-label", title +' '+window.inventory_text.add_wishlist);
    $self.find('[data-aria-live]').text('Removed from wishlist');
    saveWishlistProducts();
    updateWishlistStatus();
    jQuery('[data-wishlist-added="wishlist-' + p_id + '"]').length && jQuery('[data-wishlist-added="wishlist-' + p_id + '"]').remove();
    if(callback && typeof callback === 'function') callback();
  }

  function saveWishlistProducts(){
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist_arr));
  }

  function getWishlistHandles(){
    wishlist_arr = JSON.parse(localStorage.getItem(WISHLIST_KEY));
    if(!wishlist_arr || wishlist_arr.length === 0) return null;

    return wishlist_arr;
  }

  return {
    init: init,
    getWishlistHandles: getWishlistHandles,
    updateWishlistStatus: updateWishlistStatus,
    initWishlistProductGrid: initWishlistProductGrid,
    addProductToWishlist: addProductToWishlist,
    removeProductFromWishlist: removeProductFromWishlist
  }
})();

_theme.MiniCart = (function(){
  const isCartPage = document.querySelector('body.template-cart');
  const offerConfig = _theme.gwpConfig;
  let cartjson = _theme.gwpConfig.cart;
  let activeLineIndex = null, activeOperation = null;

  function init(){
    jQuery('[data-cart-toggle]').off('click').on('click',function(evt){
      const $self = this;
      _theme.toggleSideCart(1, $self, false);
      jQuery('#dropdown-cart .close-cart').eq(0).attr('aria-label', 'Your cart dailog, Close dailog');
    });

    jQuery('#dropdown-cart .close-cart').off('click').on('click',function(evt){
      _theme.toggleSideCart(false, null, false);
    }).off('blur').on('blur', function(){
      jQuery(this).attr('aria-label', 'Close modal');
    });

    jQuery('#dropdown-cart .mini-products-list .btn-remove').off().on('click', function(evt){
      evt.preventDefault();
      const $parent = $(this).closest('[line-index]');
      const lineIndex = $parent.attr('line-index');
      if(!lineIndex) return;

      const $input = $parent.find('input[name="updates[]"]');
      const totalQty = parseInt($parent.attr('data-total-qty')) || 0;
      let qty = $input.length ? parseInt($input.val()) : totalQty;
      let finalQty = totalQty - qty;
      finalQty = finalQty < 0 ? 0 : finalQty;

      if($input.length) $input.val(0);

      jQuery(this).parent().find('.button').addClass('disabled');
      disableCartClick(true);
      updateStatusAccessibility(lineIndex, 'remove', 'in-progress');

      _theme.Helpers.changeLineItemQty(lineIndex, finalQty, false, function(cart){
        lineItemChangeCallBack(cart,function(){
          updateStatusAccessibility(lineIndex, 'remove', 'done',1,cart);
        });
      });
    });

    jQuery('#dropdown-cart .mini-products-list .quantity-box .button').off().on('click',function(evt){
      const $statusRegion = jQuery(this).closest('[data-block-qty]').find('[data-aria-live]');

      const $parent = jQuery(this).closest('[line-index]');
      const lineIndex = $parent.attr('line-index');
      if(!lineIndex) return;

      const totalQty = parseInt($parent.attr('data-total-qty')) || 0;
      const $input = jQuery(this).parent().find('input[name="updates[]"]');
      const isPlus = jQuery(this).hasClass('plus');
      let qty = parseInt($input.val()) || 0;
      let finalQty = isPlus ? totalQty + 1 : totalQty -1;

      qty = isPlus ? qty += 1 : qty -= 1;
      qty = qty < 0 ? 0 : qty;
      finalQty = finalQty < 0 ? 0 : finalQty;
      $input.val(qty);
      
      if(qty === undefined || !lineIndex) return;

      if(isPlus) updateStatusAccessibility(lineIndex, 'plus', 'in-progress');
      else updateStatusAccessibility(lineIndex, 'minus', 'in-progress');

      jQuery(this).parent().find('.button').addClass('disabled');
      disableCartClick(true); 
      _theme.Helpers.changeLineItemQty(lineIndex, finalQty, false,lineItemChangeCallBack)
    });

    jQuery('#dropdown-cart .mini-products-list .quantity-box .button').on('keyup',function(evt){
      if(evt.code.toUpperCase() === 'ENTER'){
        jQuery(evt.target).trigger('click');
      }
    });

    if(!isCartPage){
      initGWP();
      initAutoFreeGift();
    }
  }

  function lineItemChangeCallBack(resp, callback){
    const newMiniCart = _theme.Helpers.stringToHTML(resp.sections.minicart);
    const cart = JSON.parse(newMiniCart.querySelector('minicart-block script').textContent);
    if(resp.sections) {
      cart.sections = resp.sections
      cart.section_url = resp.section_url
    }
    
    cartjson = cart;

    const srLabel = 'Shopping bag '+ cart.item_count +' ' + (cart.item_count > 1 ? 'items' : 'item');
    $('[data-cart-toggle]').attr('aria-label', srLabel);
    $("[data-cart-count]").text(cart.item_count);

    const $DropdownCart = $('#dropdown-cart');
    $('.cart_count').text(cart.item_count);

    if(cart.item_count === 0){
      $DropdownCart.addClass('cart--empty');
      $('.cart_item_text').text('Item');
      $('#dropdown-cart [data-total-count]').text('0 Item');
      disableCartClick(true);
      $('#dropdown-cart .text-continue .new-cart-btn').attr({"tabindex" : "0"}).focus();
      $('#dropdown-cart .cart_empty').attr({"role":"alert"});
      _theme.updateGWP(cart);
      _theme.focusTrap($('#dropdown-cart'),function() {
        _theme.toggleSideCart(false, null, false);
      });
      if(jQuery('.products-grid.new-products-grid').hasClass('slick-initialized')) jQuery('.products-grid.new-products-grid').slick('refresh');
      if(jQuery('.empty-cart-products').hasClass('slick-initialized')) jQuery('.empty-cart-products').slick('refresh');
    } else {
      if(newMiniCart){
        const minicartProductList = newMiniCart.querySelector('minicart-block .mini-products-list');
        const minicartSummary = newMiniCart.querySelector('minicart-block .summary');
        $DropdownCart.find('.mini-products-list').html(minicartProductList.innerHTML);
        $DropdownCart.find('.summary').html(minicartSummary.innerHTML);
        _theme.updateGWP(resp);

        $('.cart_item_text').text(cart.item_count > 1 ? 'Items': 'Items');
        $('#dropdown-cart [data-total-count]').text('Your Cart (' + cart.item_count + (cart.item_count > 1 ? ' Items' : ' Item') + ')');
        $DropdownCart.removeClass('cart--empty');
        $DropdownCart.find('.quantity-box .button').removeClass('disabled');
        disableCartClick(false);

        init(); // re-init all events

        if(callback && typeof callback === 'function') callback(cart)
        else {
          if(activeLineIndex){
            try {
              const $activeBtn = $('#dropdown-cart .mini-products-list [data-lineid="'+ activeLineIndex +'"] .quantity-box .button.'+activeOperation);
              if($activeBtn && $activeBtn.length) $activeBtn.focus();
              else {
                _theme.focusFirstTabbable($('#dropdown-cart .mini-products-list'));
              }
            } catch(err){}

            if(activeOperation === 'plus') {
              updateStatusAccessibility(activeLineIndex, 'plus', 'done', 1,cart);
            } else {
              updateStatusAccessibility(activeLineIndex, 'minus', 'done', 1,cart);
            }
          }
        }
      } else {
        $.ajax({
          type: "get",
          url: "/cart/?view=minicart",
          success:function(data){
            $DropdownCart.find('.mini-products-list').replaceWith(jQuery(data)[0]);
            $DropdownCart.find('.summary').replaceWith(jQuery(data)[2]);
            
            jQuery('.cart_item_text').text(cart.item_count > 1 ? 'Items': 'Items');
            $('#dropdown-cart [data-total-count]').text('Your Cart (' + cart.item_count + (cart.item_count > 1 ? ' Items' : ' Item') + ')');
            $DropdownCart.removeClass('cart--empty');
            $DropdownCart.find('.quantity-box .button').removeClass('disabled');
            jQuery('.cart_count').text(cart.item_count);
            
            jQuery('#header-mob-cart-items-count').text(" Cart with  " + cart.item_count + " items");
            disableCartClick(false);
            init();
            if(callback && typeof callback === 'function') callback(cart)
            else {
              if(activeLineIndex){
                try {
                  const $activeBtn = $('#dropdown-cart .mini-products-list [data-lineid="'+ activeLineIndex +'"] .quantity-box .button.'+activeOperation);
                  if($activeBtn && $activeBtn.length) $activeBtn.focus();
                  else {
                    _theme.focusFirstTabbable($('#dropdown-cart .mini-products-list'));
                  }
                } catch(err){}

                if(activeOperation === 'plus') {
                  updateStatusAccessibility(activeLineIndex, 'plus', 'done', 1,cart);
                } else {
                  updateStatusAccessibility(activeLineIndex, 'minus', 'done', 1,cart);
                }
              }
            }
          },
          error: function(){
            _theme.toggleAjaxModal(1, $.parseJSON(err.responseText).description);
          }
        });
      }
    }
  }

  function disableCartClick(disable){
    if(disable) jQuery('#dropdown-cart').addClass('processing');
    else jQuery('#dropdown-cart').removeClass('processing');
  }

  function initGWP(){
    let isAdding = false, result = null;
    if(!offerConfig || !offerConfig.gwp) return;
    if(!offerConfig.gwp.enable) {
      init(true);
      return;  
    }
    if(offerConfig.gwp.enable && offerConfig.gwp_auto.enable) return; // Can't run both offer at a time

    init();
    
    function init(stopInitialization){
      const gwp = offerConfig.gwp;
      result = getApplicableData(cartjson, gwp);
      
      if(!result.applicable && result.giftLineItem){
        _theme.Helpers.changeLineItemQty(result.giftLineItem.key, 0, 1, lineItemChangeCallBack);
      } else if(result.giftLineItem && result.giftLineItem.quantity > 1){
        _theme.Helpers.changeLineItemQty(result.giftLineItem.key, 1, 1, lineItemChangeCallBack);
      } else {
        if(!stopInitialization && result.applicable) run();
      }
    }

    function getApplicableData(cart, gwp){
      const result = {giftLineItem: null, applicable: false, applicableOffer: null, giftLineItemIndex: -1};
      
      if(!cart || cart.item_count === 0) return result;
  
      let cartTotal = cart.total_price;
      const giftLineItems = cart.items.filter(({ properties = {} }) => properties?._type === 'gwp' && properties?._discAmount !== undefined);
      const giftLineItem = giftLineItems[0];
      const giftLineItemIndex = cart.items.findIndex(({ properties = {} }) => properties?._type === 'gwp' && properties?._discAmount !== undefined);
      if(giftLineItem) cartTotal -= giftLineItem.final_line_price;
      cartTotal /= 100;
      const applicableOffer = gwp.offers.find(offer => cartTotal >= offer.threshold);
  
      if(applicableOffer) {
        result['applicableOffer'] = applicableOffer;
        if(!giftLineItem) result['applicable'] = true;
      }
  
      if(giftLineItem) {
        result['giftLineItem'] = giftLineItem;
        result['giftLineItemIndex'] = giftLineItemIndex;
  
        if(applicableOffer){
            const offerHasAddedGiftLine = applicableOffer.products.some(prod => prod.variant_id === giftLineItem.variant_id);
            result['applicable'] = offerHasAddedGiftLine && (Number(applicableOffer.discAmount) === Number(giftLineItem.properties?._discAmount));
        } else {
            result['applicable'] = false;
        }
      }

      if(giftLineItems.length > 1){
        result['applicable'] = false;
      }
  
      if(!gwp.enable) result['applicable'] = false;
  
      return result;
    }

    function openGWPModal(evt){
      if(evt){
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();
      }

      const attr = JSON.parse(jQuery('[data-gwp-modal]').attr('aria-hidden') || false);
      jQuery('[data-gwp-modal]').attr('aria-hidden', !attr).stop().slideToggle();
    }

    function closeGWPModal(evt){
      if(evt){
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();
      }

      jQuery('[data-gwp-modal]').attr('aria-hidden', true).stop().slideUp();
    }

    function cartUpdateCallBack(resp){
      closeGWPModal();
      lineItemChangeCallBack(resp);
      jQuery('[data-gwp-modal] .btn-gwp').removeClass('loading');
      isAdding = false;
    }

    function run(){
      jQuery('[data-gwp-trigger]').off('click', openGWPModal).on('click', openGWPModal);

      jQuery('[data-gwp-modal] [data-gwp-modal-close]').off('click', closeGWPModal).on('click', closeGWPModal);

      jQuery('[data-gwp-modal] .btn-gwp-apply').off('click').on('click', function(evt){
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();

        if(isAdding || !result.applicableOffer) return;
        const vid = jQuery(this).data('vid');
        if(!vid) return;
        
        isAdding = true;
        jQuery(this).addClass('loading');

        _theme.Helpers.addProductToCart(vid,1, {
          "_type": result.applicableOffer.type,
          "_discAmount": result.applicableOffer.discAmount
        }, cartUpdateCallBack);
      });

      jQuery('[data-gwp-modal] .btn-gwp-remove').off('click').on('click', function(evt){
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();

        const lineItemKey = jQuery(this).data('lineitem-key');
        if(isAdding || !lineItemKey) return;
        isAdding = true;
        jQuery(this).addClass('loading');
        _theme.Helpers.changeLineItemQty(lineItemKey,0, 1, cartUpdateCallBack);
      });

      jQuery('[data-gwp-modal] .btn-gwp-update').off('click').on('click', function(evt){
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();

        const vid = jQuery(this).data('vid');
        const lineItemKey = jQuery(this).data('lineitem-key');
        if(isAdding || !lineItemKey || !vid) return;

        isAdding = true;
        jQuery(this).addClass('loading');
        _theme.Helpers.changeLineItemQty(lineItemKey,0, 1, function(cart){
          _theme.Helpers.addProductToCart(vid,1, {
            "_type": result.applicableOffer.type,
            "_discAmount": result.applicableOffer.discAmount
          }, cartUpdateCallBack);
        });
      });
    }

  }

  function initAutoFreeGift(){
    if(!offerConfig || !offerConfig.gwp_auto) return;

    const gwp_enable = offerConfig.gwp.enable;
    const gwp_auto = offerConfig.gwp_auto;
    const enabled = gwp_auto.enable;
    const cart_total_amt = cartjson.total_price / 100;
    const threshold = Number(gwp_auto.threshold);
    const discType = gwp_auto.discType;
    const discAmount = gwp_auto.discAmount;
    const vid = gwp_auto.vid;

    if(!offerConfig.gwp_auto.enable) {
      init(true);
      return;
    }
    if(offerConfig.gwp.enable && offerConfig.gwp_auto.enable) return; // Can't run both offer at a time
    if(!enabled || !threshold || !vid) return;

    init();
    
    function init(stopInitialization){
      const $giftElem = jQuery('#dropdown-cart .mini-products-list .item[data-free-gift-added="true"]');
      if($giftElem.length){
        if(cart_total_amt < threshold || !enabled){
          const viaId = vid ? true : false;
          const lineIndex = vid ? vid : $giftElem.attr('line-index');
          _theme.Helpers.changeLineItemQty(lineIndex,0, viaId, lineItemChangeCallBack);
        } else {
          const qty = parseInt($giftElem.attr('data-quantity'));
          if(qty && qty > 1){
            const newQty = stopInitialization ? 0 : 1;
            _theme.Helpers.changeLineItemQty(vid,newQty, 1, lineItemChangeCallBack);
          }
        }
      } else {
        if(!stopInitialization && !gwp_enable && enabled){
          if(cart_total_amt >= threshold){
            _theme.Helpers.addProductToCart(vid,1, 'freeGift', lineItemChangeCallBack);
          }
        }
      }
    }
  }

  function updateStatusAccessibility(lineIndex, operation, status, shouldEmpty,cart){
    const miniCartSrOnly = jQuery('#minicart-sr-only');
    const $lineitemElem = jQuery('#dropdown-cart .mini-products-list .item[line-index="'+lineIndex+'"]');
    if(!lineIndex) jQuery('[data-aria-live]').text('');
    if(!lineIndex || !operation || $lineitemElem.length === 0) return;
    if(status === 'in-progress'){

      activeLineIndex = lineIndex;
      if(operation === 'plus') {
        // console.log("plusplus")
        miniCartSrOnly.text('please wait. increasing quantity');
        activeOperation = 'plus';
      }else if(operation === 'remove'){
        // console.log(miniCartSrOnly);
        miniCartSrOnly.text('please wait. removing item from the cart');
      }

      else {
        miniCartSrOnly.text('please wait. decreasing quantity');
        activeOperation = 'minus';
      }
    }

    if(status === 'done'){
        if(cart && cart.item_count > 0){
          if(operation === 'plus')  {miniCartSrOnly.text('Increased successfully by 1')}
          else if(operation == 'remove'){
            miniCartSrOnly.text('Item successfully removed from the cart');
          }else miniCartSrOnly.text('Decreased successfully by 1');

          if($lineitemElem.length > 0){
            $lineitemElem.find('[data-block-qty] .'+operation).focus();  
          
          }
        }else{

          $('#dropdown-cart .new-cart-btn').attr({"tabindex" : "0"}).focus();
          $('#dropdown-cart .cart_empty').attr({"role":"alert"})


        }


      activeLineIndex = null;
      activeOperation = null;
    }

    if(shouldEmpty){
      setTimeout(function(){
        miniCartSrOnly.text('');
      }, 2000);
    }

  }

  return {
    init: init,
    lineItemChangeCallBack: lineItemChangeCallBack
  }
})();

_theme.MiniCartQuickview = (function(){
  const isCartPage = document.querySelector('body.template-cart');
  const cache_product = {};
  let $activeElem = null;
  let selectedProduct = null;

  function init(){
    jQuery('#dropdown-cart').removeClass('hidden');

    jQuery(".sidecart-qv .sidecart-qv-close").click(function(a) {
      a.preventDefault(), jQuery(this).closest(".sidecart-qv").removeAttr("data-id"), _theme.toggleSideCartQv();
      if($activeElem) $activeElem.focus();
      $activeElem = null;
      jQuery("html:not(.cart-show) .wrapper-overlay.active").removeClass("active");
    });

    jQuery(".sidecart-qv").on("click", ".product_bottom .accordion-item .tab-title", function(a) {
        jQuery(this).toggleClass("open").next(".tab-content").stop().slideToggle()
    });
    
    jQuery("body").on("click", ".grid-item [data-sidecartqv]", function(e) {
      e.preventDefault();
      $activeElem = jQuery(this);
      const prod_url = jQuery(this).data("url");
      const prod_id = jQuery(this).data('id');
      const collection = jQuery(this).closest('.product-item').attr('collection');
      const varId = this.dataset.varId
      if(!prod_url || !prod_id) return;
      
      handleQVClick(prod_url, prod_id, varId);      
    });
    
    jQuery(document).on("click", ".sidecart-qv .sidecart-qv-cta button.cta-atc", function(c) {
      c.preventDefault();

      function updateATCAccessibilityStatus(status, msg){
      const ariaElem = document.querySelector('[data-aria-live]');
      if(!ariaElem || !status) return;
      switch(status){
        case 'in-progress':
          ariaElem.textContent = 'Adding';
          break;
        case 'done':
          ariaElem.textContent = 'Item added to your cart';
          break;
        case 'error':
          ariaElem.textContent = msg || 'Something went wrong';
          break;
        default:
          ariaElem.textContent = '';
      }
      }

      // Do Not Remove Code - Add Properties for GWP Discount
      let properties = {};
      let bundleVarIdElement = $(this).closest("form").find("[data-bundleVarId]");
      if (bundleVarIdElement.length > 0) {
          properties["_bundleVarId"] = bundleVarIdElement.val() || null;
      }
      // Do Not Remove Code - Add Properties for GWP Discount

      updateATCAccessibilityStatus('in-progress')
      var d = jQuery(this),
          a = getCurrentVariant(),
          b = d.closest(".sidecart-qv"),
          e = b.find("form"),
          g = b.attr("data-id"),
          f = e.find('.sidecart-qv-quantity-wrapper input[name="quantity"]').val();
      a && (jQuery(this).addClass("loading"), _theme.toggleLoading(1), _theme.Helpers.addProductToCart(a.id, f, properties, function(a) {
          itemAddedCallBack(a, d);
          var b = jQuery('#dropdown-cart .cart-recommended-products button[data-id="' + g + '"]');
          b.addClass("added").find("text").text("Added"), _theme.toggleSideCartQv(), setTimeout(function() {
              b.removeClass("added").find("text").text("Quick view")
              updateATCAccessibilityStatus('done')
          }, 300);
          _theme.toggleSideCart(1, null, true);
      }))
    });

    jQuery(document).on("click", ".sidecart-qv .sidecart-qv-quantity-wrapper button", function(d) {
      d.preventDefault();
      var b = jQuery(this).parent().find('input[type="number"]'),
          d = jQuery(this).parent().find('.sidecart-qv-qty-minus'),
          c = jQuery(this).closest(".sidecart-qv-quantity").find(".sidecart-qv-current-qty"),
          a = Number(b.val());
      // jQuery(this).hasClass("sidecart-qv-qty-minus") ? a -= 1 : a += 1
      let $announceElm=jQuery('[data-announce]')
      if(jQuery(this).hasClass("sidecart-qv-qty-minus")) {
        a -= 1 
        $announceElm.text('quantity decreased by 1')
        setTimeout(function() {
          $announceElm.text('')
        },500)
      }
      else {
        a += 1
        $announceElm.text('quantity increased by 1')
        setTimeout(function() {
          $announceElm.text('')
        },500)
      }
      a = a < 1 ? 1 : a, b.val(a), c.text(a);
      if(a > 1){
        d.attr("disabled",false)
      }else{
        d.attr("disabled",true)
      }
    });

    jQuery(document).on("change", '.sidecart-qv .sidecart-qv-options input[type="radio"]', function(l) {
      var b = getCurrentVariant();
      if (b) {
          var a = jQuery(".sidecart-qv");
          a.find('klarna-placement').attr('data-purchase-amount', b.price);
          a.find("form");
          var c = a.find(".sidecart-qv-cta .cta-atc"),
              f = a.find(".sidecart-qv-price.on-sale"),
              d = a.find(".sidecart-qv-compare-price"),
              e = a.find(".sidecart-qv-per-off");
          a.find(".sidecart-qv-klarna");
          var g = a.data("klarna-split"),
              h = Number(a.data("klarna-min")),
              i = b.price / 100 / g;
          if (b.available ? c.removeClass("disabled").removeAttr("disabled").text(window.inventory_text.add_to_cart) : c.text(window.inventory_text.sold_out).addClass("disabled").attr("disabled", "disabled"), f.html(Shopify.formatMoney(b.price, Shopify.money_format)), b.compare_at_price && b.compare_at_price > b.price) {
              d.removeClass("hidden").html(Shopify.formatMoney(b.compare_at_price, Shopify.money_format));
              var j = Math.floor((b.compare_at_price - b.price) * 100 / b.compare_at_price);
              e.removeClass("hidden").html("" + j + "% Off")
          } else d.addClass("hidden"), e.addClass("hidden");
          if (h < b.price) {
              var k = Shopify.formatMoney(i.toFixed(2), Shopify.money_format);
              a.find('[data-id="klarnaEmiAmount"]').text(k), a.find('[data-id="klarnaNonAvailabilityMessage"]').css("display", "none"), a.find('[data-id="klarnaAmountContainer"]').css("display", "inline")
          } else a.find('[data-id="klarnaAmountContainer"]').css("display", "none"), a.find('[data-id="klarnaNonAvailabilityMessage"]').css("display", "inline");

          _theme.Helpers.refreshKlarna();
      }
    });
  }

  function handleQVClick(prod_url, prod_id, variantId){
    if(!prod_url || !prod_id) return;

    let product_url = prod_url;
    if(variantId) product_url += '?variant=' + variantId;
    product_url += (product_url.includes('?') ? '&' : '?') + 'view=sidecart-qv';
    _theme.toggleLoading(1);

    if(cache_product[prod_id]){
      updateSideCartQv(cache_product[prod_id].html, prod_id);
    } else {
      jQuery.get(product_url, function(res) {
        cache_product[prod_id] = {html: res};
        updateSideCartQv(res, prod_id);
      }).done(function(res) {
        _theme.toggleLoading();
        if(window.SmartWishlistMain) window.SmartWishlistMain();
        _theme.Helpers.refreshKlarna();
        const accElemss = document.querySelectorAll('.acc-desc');
        for(let i=0; i<accElemss.length; i++){
          accElemss[i].addEventListener('click',(e)=>{
            let closestSummary = e.target.closest('summary')
            closestSummary.classList.toggle('expanded')
            closestSummary.classList.contains('expanded')?closestSummary.setAttribute('aria-expanded',true) : closestSummary.setAttribute('aria-expanded',false);
          });
        }
      }).fail(function(a) {
        // console.log(a),
        _theme.toggleLoading();
        if($activeElem) $activeElem.removeClass("loading");
        alert("Something went wrong. Please try again later")
      });
    }
  }

  function updateSideCartQv(res, prod_id){
    jQuery(".sidecart-qv").attr("data-id", prod_id);
    jQuery(".sidecart-qv .sidecart-qv-body").html(jQuery(res).find(".pdp-sidecart-qv-body").html());

    setTimeout(function() {
      const imgSlickContainer = jQuery(".sidecart-qv .sidecart-qv-images .ul");
      _theme.initSlickSlider(imgSlickContainer, {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: !1,
        arrows: true,
      }, function(slick){
        imgSlickContainer.closest(".sidecart-qv-images").removeClass("loading");
        slick.$slider.find('.slick-slide').removeAttr('tabindex aria-hidden');
          setTimeout(function() {
            slick.$slider.find('.slick-slide').removeAttr('tabindex');
          },1000);
        });
    }, 500);
    
    // jQuery(".sidecart-qv .sidecart-qv-options .swatch-element.available").first().find("input").prop("checked", true);
    _theme.toggleSideCartQv(1);
    _theme.toggleLoading();
    
    try {
      selectedProduct = JSON.parse($(".sidecart-qv").find(".sidecart-qv-body script[data-json]").text());
    } catch (error) {
      console.log(error);
    }

    _theme.focusTrap(jQuery('.sidecart-qv'),function() {
      _theme.toggleSideCartQv();
      if($activeElem) $activeElem.focus();
      $activeElem = null;
    },'details');

    jQuery('.sidecart-qv .sidecart-qv-images .ul').on('beforeChange afterChange', function(event, slick, currentSlide, nextSlide){
      slick.$slider.find('.slick-slide').removeAttr('tabindex aria-hidden');
      setTimeout(function() {
        slick.$slider.find('.slick-slide').removeAttr('tabindex');
      },1000);
    });
  }

  function getCurrentVariant() {
    var b = jQuery(".sidecart-qv"),
        c = b.find("form");
    if (c.find(".sidecart-qv-options input:checked").val()) {
        var d = null;
        try {
            var a = JSON.parse(b.find(".sidecart-qv-body script[data-json]").text());
            if (!a.available) return;
            var f = {},
                g = a.options.length;
            c.find(".sidecart-qv-options .swatch").each(function() {
                f["option" + (parseInt(jQuery(this).attr("data-option-index")) + 1)] = jQuery(this).find("input:checked").val()
            }), d = a.variants.length > 1 ? a.variants.filter(function(a) {
                switch (g) {
                    case 1:
                        return f.option1 == a.option1;
                    case 2:
                        return f.option1 == a.option1 && f.option2 == a.option2;
                    case 3:
                        return f.option1 == a.option1 && f.option2 == a.option2 && f.option3 == a.option3
                }
            })[0] : a.variants[0]
        } catch (e) {
            console.log(e)
        }
        return d || null
    }
  }

  function handleAddToCart(a, b, c) {
    window.Shopify.addItem(a, b, function(a) {
        Shopify.getCart(function(a) {
            c && "function" == typeof c && c(a)
        })
    });
  }

  function itemAddedCallBack(resp, b) {
    _theme.MiniCart.lineItemChangeCallBack(resp);
    _theme.Cart.cartMapData(resp);
    b.removeClass("loading");
    jQuery("#dropdown-cart .error-box").hide();
    jQuery("#dropdown-cart .item-added-note").removeClass("hidden");
    _theme.toggleLoading();
    _theme.initSmartWishlist();
    _theme.toggleSideCartQv();
  }

  return {
    init: init,
    handleQVClick: handleQVClick
  }
})();

_theme.ScrollEvent = (function () {
  let prevScroll = 0;
  let headerOff = 0;

  function init() {
    const $header = jQuery('header.site-header');
    const $backToTop = jQuery('[data-backtotop]');

    if ($header.length) {
      headerOff = $header.offset().top;
    }

    jQuery(window).on('scroll', function () {
      const scrollTop = jQuery(this).scrollTop();

      // Toggle back to top visibility
      $backToTop.toggleClass('active', scrollTop > 100);

      // Header fixed + scroll direction check
      if (scrollTop > headerOff) {
        jQuery('body').addClass('header-fixed');

        if (scrollTop < prevScroll) {
          jQuery('body').addClass('scroll-up');
        } else {
          jQuery('body').removeClass('scroll-up');
        }
      } else {
        jQuery('body').removeClass('header-fixed scroll-up');
      }

      prevScroll = scrollTop;
    });

    // Click event: scroll to top and focus
    $backToTop.on('click', function (e) {
      e.preventDefault();
      jQuery('html, body').animate({ scrollTop: 0 }, 800);

      const $announcementLink = jQuery('.over_location a:visible');
      const $fallbackLink = jQuery('header .find-a-store a').first();

      if ($announcementLink.length) {
        $announcementLink[0].focus();
      } else if ($fallbackLink.length) {
        $fallbackLink[0].focus();
      }
    });
  }

  return { init: init };
})();

_theme.Newsletter = (function(){
  const $emailInput = jQuery('#footer-newsletter-email');
  function moveFocus(){
    $emailInput.focus(); 
  }

  function init(){
    const formPosted = _theme.Helpers.getParamFromURL('customer_posted');
    const alreadySubscribed = _theme.Helpers.getParamFromURL('form_type');
    if(formPosted && window.gtag) {
      gtag("event", 'subscribe_newsletter', { method: 'Footer' });
      setTimeout(() => {
        _theme.track.trackData({'event': 'newsletterSubscribed'});
      }, 500);
    }
    if(!formPosted && !(alreadySubscribed == "customer") ) return;

    var popup = (!formPosted) ?  jQuery('.newsletter-success-modal.already-subscribed'): jQuery('.newsletter-success-modal.not-yet-subscribed');
    var close = popup.find('.close');
    var overlay = popup.find('.modal-overlay');
    popup.show();

    setTimeout(function(){
      _theme.focusTrap(popup, moveFocus);
    }, 250);

    _theme.Helpers.setCookie('emailSubcribeModal', 'closed', 1);
    close.off('click').on('click',function(){
        popup.fadeOut();
        moveFocus();
    });
    overlay.off('click').on('click',function(){
        popup.fadeOut();
        moveFocus();
    });
    const newURL = (!formPosted) ?  _theme.Helpers.deleteParamFromURL('form_type') :_theme.Helpers.deleteParamFromURL('customer_posted');
    history.replaceState('','', newURL);
  }

  return {init: init}
})();

_theme.handleADA = function(delay){
  setTimeout(function(){
    jQuery('[data-brands-list] .brand').attr('role','tabpanel');
  }, delay || 2000);


  const footerBeListInterval = setInterval(function(){
    const beList = document.querySelector('.site-footer-inner ul.be-list');
    if(beList){
      beList.setAttribute('role', 'list');
      beList.querySelectorAll('li').forEach(function(li){
        li.setAttribute('role', 'listitem');
      });
      // jQuery('.grecaptcha-badge').append('<label class="visually-hidden">google captcha</label>')
      if(window.location.pathname.indexOf('/a/wishlist') > -1){
        jQuery('#bookmarks h3.product_title').each(function(item, index){
          const txt = jQuery(this).text();
          if(!txt) return;
          // jQuery(this).replaceWith('<p class="product_title">'+txt+'</p>')
          jQuery(this).closest('.product').find('.image img').attr({
            'alt': txt,
            'aria-hidden': true
          });
        });
      }
      clearInterval(footerBeListInterval);
    }
  }, 1000);

  setTimeout(function(){
    if(footerBeListInterval) clearInterval(footerBeListInterval);
  }, 8000);
}

_theme.initADAEvents = function(){
  _theme.initFeaturedProductSlider('.home-featured-products[data-featured-products]');
  _theme.initbestSellerProductSlider('.home-featured-products[data-featured-products]');
  const href = window.location.href;
  jQuery('.site-nav.site-nav-desktop > li.menu-lv-1 > a').each(function(index, item){
    const link = jQuery(this).attr('href');
    if(!link) return;
    if(link === href){
        jQuery(this).addClass('current')
    }
  });

  jQuery(document).on('keyup', '[data-backtotop]', function(e) {
    if(e.which===13 || e.which === 32) {
      jQuery(e.target).trigger('click');
      jQuery('.skip-to-content-link').focus();
      }
  });
  jQuery(document).on('keyup','.smartwishlist',function(e) {
    if(e.which === 13) {
      jQuery(this).trigger('click');
    }
  });

  jQuery(document).on('keyup', '[data-has-collapse] .widget-title',function(e) {
    if(e.which===13) {
      jQuery(e.target).trigger('click');
      }
  });

  jQuery(document).on('keyup', '.faq-tab-item',function(e) {
    if(e.which===13) {
      jQuery(e.target).trigger('click');
      _theme.focusMove(jQuery('.faq-tabber-body'));
      }
  });

  jQuery(document).on('keyup', '.cart-order-link .link_item',function(e) {
    if(e.which===13) {
      jQuery(e.target).trigger('click');
      }
  });

  if(!_theme.isLaptopAndDown){
    jQuery('.sidebar-mob').remove();
  }

  jQuery('.klarna .info').attr('aria-label','know more about klarna payments');

  jQuery(document).on('keyup','.collection_offer_close',function(e) {
    if(e.which===13){
      jQuery(e.target).trigger('click');
    }
  })

  if(window.location.href.includes('wishlist')) {
    document.title="Wishlist | Fragrance Outlet";
  }

  if(window.location.href.includes('tracktor')) {
    document.title="Track Your Order | Fragrance Outlet";
  }

  setTimeout(function(){
    if(window.innerWidth > 767)jQuery('[data-griditem] [data-toggle-menu-mb]').attr({'aria-hidden': true, 'tabindex': -1});
    else jQuery('[data-griditem] [data-toggle-menu-mb]').attr({'aria-hidden': false, 'tabindex': 0});
  }, 1000);

  setTimeout(function () {
    jQuery('.slick-slide').each(function(){
      if(jQuery(this).hasClass('slick-active')) jQuery(this).find('.smartwishlist').attr('tabindex','0');
      else jQuery(this).find('.smartwishlist').attr('tabindex','-1');
    });
  },10000)
}

_theme.initSlickBtnEvent = function(){
  const slickBtns = document.querySelectorAll('.slick-initialized .slick-arrow');
  slickBtns.forEach(btn => {
    btn.removeEventListener('focusin', run);
    btn.addEventListener('focusin', run);
  });

  function run(evt){
    const target = evt.target;
    target.classList.add('show-tooltip');
    setTimeout(() => {
      target.classList.remove('show-tooltip');
    }, 2500);
  }
}


// Window Ready Events
jQuery(function(){
  _theme.loadSection();
  _theme.removeElements();
  _theme.initHeaderEvetns();
  _theme.initSlideShow();
  _theme.initPriceOff();
  _theme.redemptionPopup();
  _theme.initSmartWishlist();
  _theme.MiniCart.init();
  _theme.MiniCartQuickview.init();
  _theme.ProductGridQuickView.init();
  _theme.ScrollEvent.init();
  _theme.Newsletter.init();
  // _theme.initGTM();
  _theme.updateDOMOnResize();
  _theme.initADAEvents();
  _theme.pushBackButton.init()
  setTimeout(_theme.initLazyloadData, 1000);


  window.onresize = debounce(function(){
    const $overLocation = jQuery('.over_location_wrap .full_width_contaner');
    const hasOverLocationSectionWithSlick = $overLocation.length && $overLocation.hasClass('slick-initialized');
    if(hasOverLocationSectionWithSlick) $overLocation.slick('refresh');
  });

  // _theme.initSlickBtnEvent();
  // _theme.initTooltip();

  function initDeviceVaries(){
    const htmlSelector = document.querySelector('html');
    Array.from(htmlSelector.classList).map(function(cls){
      if(cls.indexOf('device--') > -1) htmlSelector.classList.remove(cls);
    });

    var browserZoomLevel = Math.round(window.devicePixelRatio * 100); 
    if(browserZoomLevel > 200) {
      htmlSelector.classList.add('mode--zoom');
      window.LiveChatWidget && window.LiveChatWidget.call("hide");
      if(browserZoomLevel > 300) htmlSelector.classList.add('mode--zoom-xl');
    } else {
      htmlSelector.classList.remove('mode--zoom');
      htmlSelector.classList.remove('mode--zoom-xl');
      window.LiveChatWidget && window.LiveChatWidget.call("minimize");
    }
    
    if(screen.availWidth > 767) htmlSelector.classList.add('device--ipadandup');
    else htmlSelector.classList.add('device--mobile');

    const oSClass = 'device--' + _theme.getOS();
    const deviceClass = 'device--' + _theme.getOS() + '-v-' + _theme.iPhoneVersion();
    htmlSelector.classList.add(oSClass);
    htmlSelector.classList.add(deviceClass);

    if(jQuery('.over_location_wrap .full_width_contaner').hasClass('slick-initialized')) jQuery('.full_width_contaner').slick('refresh');
  }

  initDeviceVaries();
  let resizeTimer;
  window.addEventListener('resize', function(){
    if(resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initDeviceVaries, 300);
  });
});


// Window Load Events


setTimeout(function(){

  jQuery('body').find("#WebPixelsManagerSandboxContainer").remove();

  },1000)

jQuery(window).on("load", function() {
  setTimeout(_theme.loadAppScript, 1000);

  const wishlistInterval = setInterval(() => {
    window.$ = window.jQuery;
    _theme.handleWishlistChange();
  }, 1000);
  setTimeout(function(){
    clearInterval(wishlistInterval);
  }, 5000);

  setTimeout(function(){
    jQuery('.snize-modal').remove();
    jQuery('.snize-sticky-searchbox').remove();
  },2000);

  jQuery("div#dropdown-cart  a.close.new-cart-btn.btn-black.btn-black-color").click(function(){
    _theme.toggleSideCart(false, null, false);
    jQuery(".wrapper-overlay.active").removeClass("active");
  });
});

window.addEventListener('DOMContentLoaded', function(evt){
  window.$ = window.jQuery;
  const phoneInputs = document.querySelectorAll('form input[name="customer[note][phone number]"]');
  phoneInputs.forEach(function(input){
    input.addEventListener('blur', function(evt){
      if(!this.value) return;
      const phoneNum = Number(this.value.trim());
      if(!phoneNum) return;
      _theme.Helpers.setCookie('cphone', phoneNum,7);
    });
  });
});

window.onload = function(){
  window.$ = window.jQuery;
  setTimeout(() => {
    window.$ = window.jQuery;
  }, 8000)
}
// Home Seo content
$(document).ready(function(){
  imageCardSlider();
  $('.image-card-item-link').removeAttr('aria-hidden')
  $('.home-seo-content-toggel-btn').click(function(){
    const $parent = $(this).closest('.home-seo-content-detail-container');
    if($('.home-seo-content-detail-container')[0].hasAttribute("open")){
      $('.home-seo-content-detail-container').removeAttr('open');
      $parent.find('.home-seo-content-all-detail .home-seo-content-toggel-btn').attr('tabindex', -1);
      $parent.find('.home-seo-content-detail-truncated .home-seo-content-toggel-btn').removeAttr('tabindex').focus();
    }else{
      $('.home-seo-content-detail-container').attr('open','true');
      $parent.find('.home-seo-content-detail-truncated .home-seo-content-toggel-btn').attr('tabindex', -1);
      $parent.find('.home-seo-content-all-detail .home-seo-content-toggel-btn').removeAttr('tabindex').focus();
    }
  });

  jQuery(window).on('resize', function () {
    imageCardSlider();
  });
});

var isiPad = /ipad/i.test(navigator.userAgent.toLowerCase());
var isTablet = /tablet/i.test(navigator.userAgent.toLowerCase());
function imageCardSlider() {
  if (jQuery('.image-card-container').length) {
      _theme.initSlickSlider(jQuery('.image-card-container.carouselGrid'),{
          slidesToShow: 5,
          slidesToScroll: 1,
          dots: false,
          infinite: !1,
          // prevArrow: "<button type='button' class='slick-arrow slick-prev' aria-label='previous'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''></button>",
          // nextArrow: "<button type='button' class='slick-arrow slick-next' aria-label='next'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''></button>",
          responsive: [
            {
              breakpoint: 1500,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1
              }
            }
          ]
        },function(slick){

          $(this).on('init beforeChange afterChange', function(event, slick, currentSlide, nextSlide){

            slick.$slider.find('.slick-slide').attr('tabindex', -1);
            slick.$slider.find('.slick-slide[aria-hidden="true"] a').attr('tabindex', -1);
            slick.$slider.find('.slick-slide[aria-hidden="false"] a').removeAttr('tabindex');
          
            setTimeout(function(){

              slick.$slider.find('.slick-slide').attr('tabindex', -1);
              slick.$slider.find('.slick-slide[aria-hidden="true"] a').attr('tabindex', -1);
              slick.$slider.find('.slick-slide[aria-hidden="false"] a').removeAttr('tabindex');

            },300);
        
          })
      }
      );
    
  }
}
$(document).ready(function() {
  var sliderFocusAda = setInterval(function() {
    $('.products-grid .grid-item[aria-hidden="true"]').each(function() {
        var productDetails = $(this).find('[data-bv-show="inline_rating"] a').eq(0);
        if (productDetails.length && !productDetails.is('[tabindex="-1"]')) {
            productDetails.attr("tabindex", '-1');
            clearInterval(sliderFocusAda);
        }
        setTimeout(function(){
          clearInterval(sliderFocusAda)
        },10000)
    });
  }, 2000);
  if(_theme.isMobile){
    $('.mb-area-mob').find('*').attr('aria-hidden','true')
  }
});

document.addEventListener("DOMContentLoaded", function() {
  function updateAriaLabels() {
    const addbutton = document.querySelector(".wishlisttitlecontainer .addbutton");
    const clearButton = document.querySelector(".wishlisttitlecontainer .clearall");
    const shareButton = document.querySelector(".wishlisttitlecontainer .sharebutton");

    if (addbutton) { addbutton.setAttribute("aria-label", "Add All");  }
    if (clearButton) { clearButton.setAttribute("aria-label", "Clear All");  }
    if (shareButton) { shareButton.setAttribute("aria-label", "Share Wishlist"); }
  }

  const observer = new MutationObserver(function(mutationsList) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        updateAriaLabels();
      }
    }
  });

  const targetNode = document.body;
  const config = { childList: true, subtree: true };
  observer.observe(targetNode, config);
});



/*------------------black-friday----------------*/
_theme.initSlickSlider($('.black-friday-blog'),{
  infinite : false,
  arrows: true,
  dots: false,
  prevArrow:"<button type='button' tabindex='0' role='button' aria-label='click to view previous image' class='slick-arrow slick-prev'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''><span class='sr-only'>Previous</span></button>",
  nextArrow:"<button type='button' tabindex='0' role='button' aria-label='click to view next image' class='slick-arrow slick-next'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''><span class='sr-only'>Next</span></button>",
  slidesToShow: 5,
  slidesToScroll: 1,
  spaceBetween:20,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1, spaceBetween:20,
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,

      }
    },
    {
      breakpoint:640,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },

      {
        breakpoint:480,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1
        }
      }
  ]
})



_theme.initSlickSlider($('.product_black_friday'),{
  infinite : false,
  arrows: true,
  dots: false,
  prevArrow:"<button type='button' tabindex='0' role='button' aria-label='click to view previous image' class='slick-arrow slick-prev'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''><span class='sr-only'>Previous</span></button>",
  nextArrow:"<button type='button' tabindex='0' role='button' aria-label='click to view next image' class='slick-arrow slick-next'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''><span class='sr-only'>Next</span></button>",
  slidesToShow: 4,
  slidesToScroll: 1,
  spaceBetween:20,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1, spaceBetween:20,
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,

      }
    },
    {
      breakpoint:640,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },

      {
        breakpoint:480,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1
        }
      }
  ]
})
_theme.initSlickSlider($('.blog-brand-black-friday'),{
  infinite : false,
  arrows: true,
  dots: false,
  prevArrow:"<button type='button' tabindex='0' role='button' aria-label='click to view previous image' class='slick-arrow slick-prev'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''><span class='sr-only'>Previous</span></button>",
  nextArrow:"<button type='button' tabindex='0' role='button' aria-label='click to view next image' class='slick-arrow slick-next'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''><span class='sr-only'>Next</span></button>",
  slidesToShow: 6,
  slidesToScroll: 1,
  spaceBetween:10,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1, spaceBetween:20,
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,

      }
    },
    {
      breakpoint:640,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },


      {
        breakpoint:480,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1
        }
      }
  ]
})
function prodSlider(){
  const cartSlider = jQuery('.empty-cart-products');
  let isCartPageTrue = false;
  if(document.querySelector('body.template-cart')){
      isCartPageTrue = true;
  }
  _theme.initSlickSlider(cartSlider, {
    dots: false,
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: isCartPageTrue?3:2.25,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: false,
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 500,
        settings: {
          dots: false,
          arrows: true,
          slidesToShow: 1.5,
          slidesToScroll: 1
        }
      }
    ]
    },function(){
      cartSlider.on('afterChange', function(event, slick, currentSlide, nextSlide){
      slick.$slider.find('.slick-slide').removeAttr('tabindex');
      slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
      setTimeout(function(){
        slick.$slider.find('.slick-slide').removeAttr('tabindex');
      }, 1000);
      jQuery('.slick-slide').each(function(){
        if(jQuery(this).hasClass('slick-active')){
          jQuery(this).find('.smartwishlist').attr('tabindex','0');
        }
        else{
          jQuery(this).find('.smartwishlist').attr('tabindex','-1');
        }
      });
    });
  });
}
  document.addEventListener('DOMContentLoaded', function(){
  prodSlider();
  document.querySelectorAll('[data-gif-logo]').forEach((gifLogo) => {
    const gifSrc = gifLogo.dataset.gifLogo;
    const gifSrcAlt = gifLogo.dataset.afterPauseAlt;
  
    if (gifSrc) {
      setTimeout(() => {
        gifLogo.src = '';
        gifLogo.src = gifSrc;
  
        if (gifSrcAlt) {
          gifLogo.alt = gifSrcAlt;
        }
      }, 5000);
    }
  }); 
  document.querySelector('#google-merchantwidget-iframe-wrapper iframe')?.setAttribute('title', 'Google Merchant Widget');
  const observer = new MutationObserver((mutations, obs) => {
    const frame = document.querySelector('#li_sync_frame');
    if (frame) {
      frame.setAttribute('title', 'Google Merchant Widget');
      obs.disconnect(); 
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})